
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire49a6"];
var parcelRegister = parcelRequire.register;
parcelRegister("ljW5d", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8586d6bc0be56c0$var$_extends2 = $l4FIw((parcelRequire("5WrMC")));

var $f8586d6bc0be56c0$var$_react = $l4FIw((parcelRequire("7eprg")));

var $f8586d6bc0be56c0$var$_PulseNotificationMessage = $l4FIw((parcelRequire("6D9N1")));

var $6oEXm = parcelRequire("6oEXm");

var $f8586d6bc0be56c0$var$localizationStrings = $f8586d6bc0be56c0$var$_interopRequireWildcard((parcelRequire("afE2Z")));
function $f8586d6bc0be56c0$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f8586d6bc0be56c0$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f8586d6bc0be56c0$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f8586d6bc0be56c0$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/ const $f8586d6bc0be56c0$var$PulseNotificationMessageWrapper = (props)=>{
    const { locale: locale, ...otherProps } = props;
    return /*#__PURE__*/ $f8586d6bc0be56c0$var$_react.default.createElement($6oEXm.IntlProvider, {
        locale: locale,
        messages: $f8586d6bc0be56c0$var$localizationStrings
    }, /*#__PURE__*/ $f8586d6bc0be56c0$var$_react.default.createElement($f8586d6bc0be56c0$var$_PulseNotificationMessage.default, (0, $f8586d6bc0be56c0$var$_extends2.default)({}, otherProps, {
        showError: false
    })));
};
/**
 * TODO: Need to check how it uses localizationStrings
 * TODO: defaultProps
 */ $f8586d6bc0be56c0$var$PulseNotificationMessageWrapper.defaultProps = {
    locale: "en-US",
    localizationStrings: {
        markAsUnread: "Mark as unread",
        markAsRead: "Mark as read",
        High: "High",
        Approve: "Approve",
        Reject: "Reject",
        DismissReminder: "Dismiss reminder",
        DismissAlert: "Dismiss",
        Snooze: "Remind me",
        DeleteReminder: "Delete reminder",
        EditReminder: "Edit reminder",
        RemindMeTomorrow: "Remind me tomorrow",
        RemindMe60Min: "Remind me in an hour",
        RemindMe15Min: "Remind me in 15 minutes",
        RemindMe5Min: "Remind me in 5 minutes"
    }
};
var $f8586d6bc0be56c0$var$_default = $f8586d6bc0be56c0$var$PulseNotificationMessageWrapper;
module.exports.default = $f8586d6bc0be56c0$var$_default;

});
parcelRegister("6D9N1", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.MarkAsRead = module.exports.FlyoutActions = void 0;

var $4d3dfaa35b762634$var$_extends2 = $l4FIw((parcelRequire("5WrMC")));

var $4d3dfaa35b762634$var$_react = $4d3dfaa35b762634$var$_interopRequireWildcard((parcelRequire("7eprg")));



var $4d3dfaa35b762634$var$_Close = $l4FIw((parcelRequire("8GCxQ")));

var $4d3dfaa35b762634$var$_Button = $l4FIw((parcelRequire("iNgWr")));

var $4d3dfaa35b762634$var$_CheckmarkCircle = $l4FIw((parcelRequire("7avf1")));

var $4d3dfaa35b762634$var$_OverlayTrigger = $l4FIw((parcelRequire("aKT0j")));

var $4d3dfaa35b762634$var$_Tooltip = $l4FIw((parcelRequire("72PXO")));

var $4d3dfaa35b762634$var$_PulseUtil = $l4FIw((parcelRequire("h9Sqk")));

var $4d3dfaa35b762634$var$_MarkAsRead = $l4FIw((parcelRequire("bGuZT")));

var $4d3dfaa35b762634$var$_Reminders = $l4FIw((parcelRequire("5Trgf")));

var $4d3dfaa35b762634$var$types = $4d3dfaa35b762634$var$_interopRequireWildcard((parcelRequire("je1Hc")));

var $4d3dfaa35b762634$var$_classnames = $l4FIw((parcelRequire("g3elz")));

var $4d3dfaa35b762634$var$_RemindersDropDown = $l4FIw((parcelRequire("17UAX")));

var $awzum = parcelRequire("awzum");

var $a6smq = parcelRequire("a6smq");

var $4d3dfaa35b762634$var$_IconMapper = $l4FIw((parcelRequire("kuUz8")));

var $5hKOy = parcelRequire("5hKOy");

var $4d3dfaa35b762634$var$_metrics = $l4FIw((parcelRequire("2uDvu")));

var $6oEXm = parcelRequire("6oEXm");

var $4d3dfaa35b762634$var$localizationStrings = $4d3dfaa35b762634$var$_interopRequireWildcard((parcelRequire("7BDZy")));

var $2ljLL = parcelRequire("2ljLL");

var $1Rodh = parcelRequire("1Rodh");
function $4d3dfaa35b762634$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($4d3dfaa35b762634$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $4d3dfaa35b762634$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $4d3dfaa35b762634$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/ const $4d3dfaa35b762634$var$mapStateToProps = ()=>({});
const $4d3dfaa35b762634$var$mapDispatchToProps = (dispatch)=>({
        dispatchToToggleReadStatus: (notification)=>dispatch((0, $4d3dfaa35b762634$var$_MarkAsRead.default)(notification)),
        dispatchToSetReminder: (notification, serverTime, reminderTime)=>dispatch($4d3dfaa35b762634$var$_Reminders.default.setReminder(notification, serverTime, reminderTime)),
        dispatchToRemoveReminder: (notification)=>dispatch($4d3dfaa35b762634$var$_Reminders.default.removeReminder(notification)),
        dispatchToMarkReminderAsShown: (id)=>{
            dispatch({
                type: $4d3dfaa35b762634$var$types.MARK_REMINDER_AS_SHOWN,
                ids: [
                    id
                ]
            });
        },
        dispatchToMarkNotificationAsShown: (id)=>{
            dispatch({
                type: $4d3dfaa35b762634$var$types.MARK_NOTIFICATIONS_AS_SHOWN,
                ids: [
                    id
                ]
            });
        },
        dispatchToSetNotificationURLValidity: (flag)=>{
            dispatch({
                type: $4d3dfaa35b762634$var$types.NOTIFICATION_URL_LINK_VALIDATION,
                payload: flag
            });
        }
    });
const $4d3dfaa35b762634$var$pushMetrics = function(metrics, isFloatingAlert, isReminder) {
    let isFlyout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    let trackEvent = arguments.length > 4 ? arguments[4] : undefined;
    let notificationId = arguments.length > 5 ? arguments[5] : undefined;
    let requestedIsRead = arguments.length > 6 ? arguments[6] : undefined;
    const omegaPayload = {
        element: `${$1Rodh.ELEMENT_TYPES.BUTTON} - ${$1Rodh.ELEMENT_NAME.MARK_AS_READ_BUTTON}`,
        action: $1Rodh.ACTION.CLICK,
        feature: isFlyout ? $1Rodh.FEATURE.NOTIFICATION_FLYOUT : $1Rodh.FEATURE.NOTIFICATION_PAGE,
        widget: $1Rodh.WIDGET_NAME.MESSAGE_FLOATING_ACTIONS,
        widgetType: $1Rodh.WIDGET_TYPE.BUTTON,
        attributes: {
            isFloatingAlert: `${isFloatingAlert}`,
            isFlyout: `${isFlyout}`,
            isReminder: `${isReminder}`,
            isReaAction: `${requestedIsRead}`,
            notificationId: notificationId
        }
    };
    let eventName = "flyout.notifications.markAsRead.click";
    if (isFloatingAlert) eventName = "flyout.floatingAlert.markAsRead.click";
    else if (isReminder) eventName = "flyout.reminder.markAsRead.click";
    trackEvent(omegaPayload);
    metrics.event(eventName, {
        region: window.config && window.config.region
    });
};
const $4d3dfaa35b762634$var$PriorityFlag = (props)=>{
    const { formatMessage: formatMessage } = props;
    return /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement("div", {
        className: "pulse-notification-message-priority-tag"
    }, formatMessage({
        id: "High",
        defaultMessage: "High",
        description: "High"
    }));
};
const $4d3dfaa35b762634$var$TimeAgo = (props)=>{
    const { createdTimestamp: createdTimestamp } = props;
    return /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$_OverlayTrigger.default, {
        delayShow: $awzum.TOOLTIP_DELAY_ON_ACTIONS_BUTTON,
        placement: "top",
        trigger: "hover"
    }, /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement("div", {
        className: "pulse-notification-message-time-ago"
    }, $4d3dfaa35b762634$var$_PulseUtil.default.formatTimeAgo(createdTimestamp, true)), /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$_Tooltip.default, null, $4d3dfaa35b762634$var$_PulseUtil.default.formatDate(createdTimestamp)));
};
const $4d3dfaa35b762634$var$MarkAsRead = (props)=>{
    const trackEvent = (0, $2ljLL.useOmegaTrack)();
    const { pulseMessageObject: pulseMessageObject, isFloatingAlert: isFloatingAlert, isReminder: isReminder, isFlyout: isFlyout, formatMessage: formatMessage, metrics: metrics, dispatchToMarkReminderAsShown: dispatchToMarkReminderAsShown, dispatchToToggleReadStatus: dispatchToToggleReadStatus } = props;
    /**
   * This function will mark the notification as read
   * and will revert the store changes if the API
   * call was unsuccessful.
   * @param event
   */ const handleClickOnMarkAsRead = async (event)=>{
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const requestedIsRead = !pulseMessageObject.isRead;
        $4d3dfaa35b762634$var$pushMetrics(metrics, isFloatingAlert, isReminder, isFlyout, trackEvent, pulseMessageObject.id, requestedIsRead);
        const success = await dispatchToToggleReadStatus(pulseMessageObject);
        if (success && isReminder) dispatchToMarkReminderAsShown(pulseMessageObject.id);
    };
    return /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$_OverlayTrigger.default, {
        delayShow: $awzum.TOOLTIP_DELAY_ON_ACTIONS_BUTTON,
        placement: "top",
        trigger: "hover"
    }, /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement("div", {
        className: "pulse-notification-message-actions-button"
    }, /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$_Button.default, {
        className: "notification-mark-as-read-button",
        icon: /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$_CheckmarkCircle.default, {
            size: "S"
        }),
        label: null,
        onClick: async (event)=>await handleClickOnMarkAsRead(event),
        quiet: true,
        variant: "action"
    })), /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$_Tooltip.default, null, pulseMessageObject.isRead ? formatMessage({
        id: "markAsUnread",
        defaultMessage: "Mark as unread",
        description: "Mark as unread"
    }) : formatMessage({
        id: "markAsRead",
        defaultMessage: "Mark as read",
        description: "Mark as read"
    })));
};
module.exports.MarkAsRead = $4d3dfaa35b762634$var$MarkAsRead;
const $4d3dfaa35b762634$var$CrossButton = (props)=>{
    const { pulseMessageObject: pulseMessageObject, isReminder: isReminder, isFloatingAlert: isFloatingAlert, onMessageCloseClicked: onMessageCloseClicked, formatMessage: formatMessage, metrics: metrics, dispatchToMarkNotificationAsShown: dispatchToMarkNotificationAsShown, dispatchToMarkReminderAsShown: dispatchToMarkReminderAsShown } = props;
    const handleClickOnCrossButton = (event)=>{
        event.preventDefault();
        if (isReminder) {
            metrics.event("flyout.reminder.closed", {
                region: window.config && window.config.region
            });
            dispatchToMarkReminderAsShown(pulseMessageObject.id);
        }
        if (isFloatingAlert) {
            dispatchToMarkNotificationAsShown(pulseMessageObject.id);
            onMessageCloseClicked();
        }
    };
    return /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$_OverlayTrigger.default, {
        delayShow: $awzum.TOOLTIP_DELAY_ON_ACTIONS_BUTTON,
        offset: 10,
        placement: "top",
        trigger: "hover"
    }, /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement("div", {
        className: "pulse-notification-message-actions-button"
    }, /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$_Button.default, {
        icon: /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$_Close.default, {
            size: "S"
        }),
        label: null,
        onClick: handleClickOnCrossButton,
        quiet: true,
        variant: "action"
    })), /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$_Tooltip.default, null, isReminder ? formatMessage({
        id: "DismissReminder",
        defaultMessage: "Dismiss reminder",
        description: "Dismiss reminder"
    }) : formatMessage({
        id: "DismissAlert",
        defaultMessage: "Dismiss",
        description: "Dismiss"
    })));
};
const $4d3dfaa35b762634$var$SnoozeButton = (props)=>{
    const trackEvent = (0, $2ljLL.useOmegaTrack)();
    const { pulseMessageObject: pulseMessageObject, isFlyout: isFlyout = false, isReminder: isReminder, setReminderDropdownOpen: setReminderDropdownOpen, serverTimeStamp: serverTimeStamp, clientTimeStamp: clientTimeStamp, metrics: metrics, dispatchToMarkReminderAsShown: dispatchToMarkReminderAsShown, dispatchToSetReminder: dispatchToSetReminder, dispatchToRemoveReminder: dispatchToRemoveReminder, locale: locale } = props;
    const isReminderActive = pulseMessageObject.reminderTime && pulseMessageObject.reminderTime > $4d3dfaa35b762634$var$_PulseUtil.default.getServerTimeFromNow(serverTimeStamp, clientTimeStamp);
    const omegaPayload = {
        element: `${$1Rodh.ELEMENT_TYPES.BUTTON} - reminder button`,
        action: $1Rodh.ACTION.CLICK,
        feature: isFlyout ? $1Rodh.FEATURE.NOTIFICATION_FLYOUT : $1Rodh.FEATURE.NOTIFICATION_PAGE,
        widget: $1Rodh.WIDGET_NAME.MESSAGE_FLOATING_ACTIONS,
        widgetType: $1Rodh.WIDGET_TYPE.BUTTON,
        attributes: {
            isReminderActive: `${isReminderActive}`,
            isReminderMessage: `${isReminder}`,
            notificationId: pulseMessageObject.id
        }
    };
    return /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($6oEXm.IntlProvider, {
        locale: locale,
        messages: $4d3dfaa35b762634$var$localizationStrings
    }, /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$_RemindersDropDown.default, {
        isReminderActive: isReminderActive,
        onReminderDeleted: async ()=>{
            dispatchToRemoveReminder(pulseMessageObject);
            setTimeout(()=>{
                trackEvent({
                    ...omegaPayload,
                    element: `${$1Rodh.ELEMENT_TYPES.BUTTON} - reminder delete button`
                });
            }, 0);
            if (isReminder) dispatchToMarkReminderAsShown(pulseMessageObject.id);
        },
        onReminderDropDownClose: ()=>{
            trackEvent({
                ...omegaPayload,
                element: `${$1Rodh.ELEMENT_TYPES.BUTTON} - reminder dropdown closed`
            });
            setReminderDropdownOpen(false);
        },
        onReminderDropDownOpen: ()=>{
            trackEvent({
                ...omegaPayload,
                element: `${$1Rodh.ELEMENT_TYPES.BUTTON} - reminder dropdown opened`
            });
            setReminderDropdownOpen(true);
        },
        onReminderSelected: (futureTime)=>{
            const serverTime = $4d3dfaa35b762634$var$_PulseUtil.default.getServerTimeFromNow(serverTimeStamp, clientTimeStamp);
            dispatchToSetReminder(pulseMessageObject, serverTime, futureTime);
            setTimeout(()=>{
                trackEvent({
                    ...omegaPayload,
                    element: `${$1Rodh.ELEMENT_TYPES.BUTTON} - reminder button [${futureTime}]`
                });
            }, 0);
            //TODO: Duplicate event. Need to remove.
            metrics.event("notification.reminder.set", {
                region: window.config && window.config.region
            });
            if (isReminder) {
                //push metrics for setting `reminder` on existing displayed reminders
                metrics.event("notification.reminder.onReminder.set", {
                    region: window.config && window.config.region
                });
                dispatchToMarkReminderAsShown(pulseMessageObject.id);
            }
        },
        reminderTime: pulseMessageObject.reminderTime
    }));
};
const $4d3dfaa35b762634$var$FloatingActions = (props)=>{
    const { hoverStatus: hoverStatus, isReminderDropDownOpen: isReminderDropDownOpen, pulseMessageObject: pulseMessageObject } = props;
    const style = "pulse-notification-message-actions-bar";
    return /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement("div", {
        className: style
    }, /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$TimeAgo, {
        createdTimestamp: pulseMessageObject.createdTimestamp
    }), (hoverStatus || isReminderDropDownOpen) && /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$SnoozeButton, props), /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$CrossButton, props));
};
const $4d3dfaa35b762634$var$FlyoutActions = (props)=>{
    const { hoverStatus: hoverStatus, isReminderDropDownOpen: isReminderDropDownOpen, pulseMessageObject: pulseMessageObject, serverTimeStamp: serverTimeStamp, clientTimeStamp: clientTimeStamp } = props;
    const style = "pulse-notification-message-actions-bar";
    const isReminderActive = pulseMessageObject.reminderTime && pulseMessageObject.reminderTime > $4d3dfaa35b762634$var$_PulseUtil.default.getServerTimeFromNow(serverTimeStamp, clientTimeStamp);
    if (hoverStatus || isReminderDropDownOpen) return /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement("div", {
        className: style
    }, !pulseMessageObject.fromReminder && /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$MarkAsRead, props), /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$SnoozeButton, props), /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$TimeAgo, {
        createdTimestamp: pulseMessageObject.createdTimestamp
    }));
    return /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement("div", {
        className: style
    }, isReminderActive && /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$SnoozeButton, props), /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$TimeAgo, {
        createdTimestamp: pulseMessageObject.createdTimestamp
    }));
};
module.exports.FlyoutActions = $4d3dfaa35b762634$var$FlyoutActions;
const $4d3dfaa35b762634$var$Avatar = (props)=>{
    const { pulseMessageObject: pulseMessageObject } = props;
    return /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$_OverlayTrigger.default, {
        delayShow: $awzum.TOOLTIP_DELAY_ON_AVATAR,
        placement: "top",
        trigger: "hover"
    }, /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement("div", {
        className: "pulse-message-avatar"
    }, pulseMessageObject.isUser ? /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement("img", {
        alt: "avatar",
        className: "pulse-notification-user-avatar",
        src: pulseMessageObject.avatar ? pulseMessageObject.avatar : $awzum.DEFAFULT_AVATAR_URL
    }) : /*#__PURE__*/ //TODO: Need to check if avatar is a string or an object
    $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$_IconMapper.default, {
        product: pulseMessageObject.product ? pulseMessageObject.product : "Experience Cloud"
    })), /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$_Tooltip.default, {
        className: "avatar-tooltip-label"
    }, pulseMessageObject.isUser ? `${pulseMessageObject.firstName} ${pulseMessageObject.lastName}` : pulseMessageObject.product));
};
const $4d3dfaa35b762634$var$Actions = (props)=>{
    const { formatMessage: formatMessage } = props;
    return /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement("div", {
        className: "pulse-notification-message-row3"
    }, /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement("div", {
        className: "pulse-notification-message-action-buttons-right"
    }, /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$_Button.default, {
        className: "pulse-notification-message-reject-button",
        quiet: true,
        variant: "primary"
    }, formatMessage({
        id: "Reject",
        defaultMessage: "Reject",
        description: "Reject"
    })), /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$_Button.default, {
        className: "pulse-notification-message-approve-button",
        quiet: true,
        variant: "primary"
    }, formatMessage({
        id: "Approve",
        defaultMessage: "Approve",
        description: "Approve"
    }))));
};
const $4d3dfaa35b762634$var$PulseNotificationMessage = (props)=>{
    const { pulseMessageObject: // eslint-disable-next-line @typescript-eslint/no-empty-function
    pulseMessageObject, isFloatingAlert: isFloatingAlert, renderCrossButton: renderCrossButton, isReminder: isReminder, isFlyout: isFlyout, intl: intl, serverTimeStamp: serverTimeStamp, clientTimeStamp: clientTimeStamp, onMessageCloseClicked: onMessageCloseClicked = ()=>{}, dispatchToSetNotificationURLValidity: dispatchToSetNotificationURLValidity, dispatchToToggleReadStatus: dispatchToToggleReadStatus, dispatchToMarkReminderAsShown: dispatchToMarkReminderAsShown, dispatchToMarkNotificationAsShown: dispatchToMarkNotificationAsShown, dispatchToSetReminder: dispatchToSetReminder, dispatchToRemoveReminder: dispatchToRemoveReminder } = props;
    const { locale: locale, formatMessage: formatMessage } = intl;
    const [hoverStatus, setHoverStatus] = (0, $4d3dfaa35b762634$var$_react.useState)(false);
    const buttonRef = (0, $4d3dfaa35b762634$var$_react.useRef)();
    const [isReminderDropDownOpen, setReminderDropdownOpen] = (0, $4d3dfaa35b762634$var$_react.useState)(false);
    const textRef = (0, $4d3dfaa35b762634$var$_react.useRef)(null);
    const productRef = (0, $4d3dfaa35b762634$var$_react.useRef)(null);
    const [showProductTooltip, setShowProductTooltip] = (0, $4d3dfaa35b762634$var$_react.useState)(false);
    const backgroundStyle = pulseMessageObject.isRead || isFloatingAlert ? "pulse-notification-read-background" : "pulse-notification-unread-background";
    const metrics = (0, $4d3dfaa35b762634$var$_metrics.default)("exc.pulse.components.message.PulseNotificationMessage");
    const trackEvent = (0, $2ljLL.useOmegaTrack)();
    const { trackEvent: trackOmegaEvent } = (0, $2ljLL.useOmegaEvent)();
    const mouseEnterHandler = ()=>{
        setShowProductTooltip($4d3dfaa35b762634$var$_PulseUtil.default.isTextOverFlown(productRef));
    };
    const onNotificationClick = async ()=>{
        metrics.event("notification.navigationLink.click", {
            region: window.config && window.config.region,
            type: pulseMessageObject.type,
            subtype: pulseMessageObject.subtype,
            product: pulseMessageObject.product
        });
        const validUrl = $4d3dfaa35b762634$var$_PulseUtil.default.validateUrl(pulseMessageObject.url);
        dispatchToSetNotificationURLValidity(validUrl);
        !validUrl && setTimeout(()=>dispatchToSetNotificationURLValidity(!validUrl), 3000);
        if (isReminder) dispatchToMarkReminderAsShown(pulseMessageObject.id);
        if (!pulseMessageObject.isRead || pulseMessageObject.fromReminder) {
            dispatchToToggleReadStatus(pulseMessageObject);
            const success = await (0, $4d3dfaa35b762634$var$_MarkAsRead.default)(pulseMessageObject);
            if (success) dispatchToMarkNotificationAsShown(pulseMessageObject.id);
        }
    };
    const onKeyDownSpace = (event)=>{
        if (event.target !== buttonRef.current) return;
        if (event.key === " " || event.key === "Enter") {
            event.preventDefault();
            buttonRef.current.click();
        }
    };
    const showToolTip = $4d3dfaa35b762634$var$_PulseUtil.default.isTextOverFlown(textRef);
    return /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement("div", {
        className: (0, $4d3dfaa35b762634$var$_classnames.default)("pulse-notification-message-root", backgroundStyle),
        onMouseEnter: ()=>setHoverStatus(true),
        onMouseLeave: ()=>setHoverStatus(false),
        onMouseMove: ()=>setHoverStatus(true)
    }, /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement("a", (0, $4d3dfaa35b762634$var$_extends2.default)({
        onClick: trackOmegaEvent({
            element: $1Rodh.ELEMENT_TYPES.LINK,
            action: $1Rodh.ACTION.CLICK,
            feature: isFlyout ? $1Rodh.FEATURE.NOTIFICATION_FLYOUT : $1Rodh.FEATURE.NOTIFICATION_PAGE,
            widget: $1Rodh.WIDGET_NAME.NOTIFICATION_MESSAGE,
            widgetType: $1Rodh.WIDGET_TYPE.LINK,
            attributes: {
                priority: pulseMessageObject.priority,
                isReminder: `${isReminder}`,
                isFloatingAlert: `${isFloatingAlert}`,
                notificationId: pulseMessageObject.id
            },
            onEvent: onNotificationClick
        }),
        onKeyDown: onKeyDownSpace,
        ref: buttonRef,
        role: "button",
        style: {
            textDecoration: "none",
            color: "inherit"
        },
        tabIndex: 0
    }, $4d3dfaa35b762634$var$_PulseUtil.default.validateUrl(pulseMessageObject.url) && {
        href: pulseMessageObject.url
    }, $4d3dfaa35b762634$var$_PulseUtil.default.validateUrl(pulseMessageObject.url) && {
        target: "_blank"
    }), /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement("div", {
        className: "pulse-notification-message-row1"
    }, pulseMessageObject.priority === "high" && /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$PriorityFlag, {
        formatMessage: formatMessage
    }), /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$_OverlayTrigger.default, {
        delayShow: $awzum.TOOLTIP_DELAY_ON_MESSAGE,
        placement: "top",
        trigger: "hover"
    }, /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement("div", {
        className: "pulse-notification-message-product-name avatar-tooltip-label",
        onMouseEnter: mouseEnterHandler,
        ref: productRef
    }, " ", pulseMessageObject.product), /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$_Tooltip.default, {
        style: showProductTooltip ? {
            visibility: "visible"
        } : {
            visibility: "hidden"
        }
    }, " ", pulseMessageObject.product)), isFloatingAlert || renderCrossButton ? /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$FloatingActions, {
        clientTimeStamp: clientTimeStamp,
        dispatchToMarkNotificationAsShown: dispatchToMarkNotificationAsShown,
        dispatchToMarkReminderAsShown: dispatchToMarkReminderAsShown,
        dispatchToRemoveReminder: dispatchToRemoveReminder,
        dispatchToSetReminder: dispatchToSetReminder,
        formatMessage: formatMessage,
        hoverStatus: hoverStatus,
        isFloatingAlert: isFloatingAlert,
        isFlyout: isFlyout,
        isReminder: isReminder,
        isReminderDropDownOpen: isReminderDropDownOpen,
        locale: locale,
        metrics: metrics,
        onMessageCloseClicked: onMessageCloseClicked,
        pulseMessageObject: pulseMessageObject,
        serverTimeStamp: serverTimeStamp,
        setReminderDropdownOpen: setReminderDropdownOpen
    }) : /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$FlyoutActions, {
        clientTimeStamp: clientTimeStamp,
        dispatchToMarkReminderAsShown: dispatchToMarkReminderAsShown,
        dispatchToRemoveReminder: dispatchToRemoveReminder,
        dispatchToSetReminder: dispatchToSetReminder,
        dispatchToToggleReadStatus: dispatchToToggleReadStatus,
        formatMessage: formatMessage,
        hoverStatus: hoverStatus,
        isFloatingAlert: isFloatingAlert,
        isFlyout: isFlyout,
        isReminder: isReminder,
        isReminderDropDownOpen: isReminderDropDownOpen,
        locale: locale,
        metrics: metrics,
        pulseMessageObject: pulseMessageObject,
        serverTimeStamp: serverTimeStamp,
        setReminderDropdownOpen: setReminderDropdownOpen
    })), /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement("div", {
        className: "pulse-notification-message-row2"
    }, /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement("div", {
        className: "pulse-notification-message-row2-col1"
    }, /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$Avatar, {
        pulseMessageObject: pulseMessageObject
    })), /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$_OverlayTrigger.default, {
        delayShow: $awzum.TOOLTIP_DELAY_ON_MESSAGE,
        placement: "right",
        trigger: "hover"
    }, /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement("div", {
        className: "pulse-notification-message-row2-col2",
        ref: textRef
    }, /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: pulseMessageObject.text
        }
    })), /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$_Tooltip.default, {
        style: showToolTip ? {
            visibility: "visible"
        } : {
            visibility: "hidden"
        }
    }, /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: pulseMessageObject.text
        }
    })))), pulseMessageObject.isActionable && /*#__PURE__*/ $4d3dfaa35b762634$var$_react.default.createElement($4d3dfaa35b762634$var$Actions, {
        formatMessage: formatMessage
    })));
};
var $4d3dfaa35b762634$var$_default = (0, $a6smq.default)((0, $5hKOy.connect)(null, $4d3dfaa35b762634$var$mapDispatchToProps)($4d3dfaa35b762634$var$PulseNotificationMessage));
module.exports.default = $4d3dfaa35b762634$var$_default;

});
parcelRegister("7avf1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5381b36fb6f8f2bf$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $32iuA = parcelRequire("32iuA");
var $5381b36fb6f8f2bf$var$_Icon2 = $5381b36fb6f8f2bf$var$_interopRequireDefault($32iuA);

var $7eprg = parcelRequire("7eprg");
var $5381b36fb6f8f2bf$var$_react2 = $5381b36fb6f8f2bf$var$_interopRequireDefault($7eprg);
function $5381b36fb6f8f2bf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}


var $5381b36fb6f8f2bf$var$WrappedIcon = function WrappedIcon(props) {
    return $5381b36fb6f8f2bf$var$_react2.default.createElement($5381b36fb6f8f2bf$var$_Icon2.default, $5381b36fb6f8f2bf$var$_extends({}, props, {
        icon: {
            18: (parcelRequire("akHj1")),
            24: (parcelRequire("fCGko"))
        }
    }));
};
$5381b36fb6f8f2bf$var$WrappedIcon.displayName = "CheckmarkCircle";
module.exports.default = $5381b36fb6f8f2bf$var$WrappedIcon;

});
parcelRegister("akHj1", function(module, exports) {
"use strict";

var $7eprg = parcelRequire("7eprg");
module.exports = $7eprg.createElement("svg", {
    viewBox: "0 0 36 36"
}, $7eprg.createElement("path", {
    d: "M16 2a16 16 0 1 0 16 16A16 16 0 0 0 16 2zm10.666 9.08L14.018 27.341a1.208 1.208 0 0 1-.875.461h-.072a1.2 1.2 0 0 1-.85-.352l-7.785-7.793a1.2 1.2 0 0 1 0-1.7l1.326-1.325a1.2 1.2 0 0 1 1.7 0l5.338 5.349L23.315 8.473A1.2 1.2 0 0 1 25 8.263L26.455 9.4a1.2 1.2 0 0 1 .211 1.68z"
}));

});

parcelRegister("fCGko", function(module, exports) {
"use strict";

var $7eprg = parcelRequire("7eprg");
module.exports = $7eprg.createElement("svg", {
    viewBox: "0 0 48 48"
}, $7eprg.createElement("path", {
    d: "M24 4.1A19.9 19.9 0 1 0 43.9 24 19.9 19.9 0 0 0 24 4.1zm12.563 12.587L22.018 35.341a1.208 1.208 0 0 1-.875.461h-.072a1.2 1.2 0 0 1-.85-.352l-7.785-7.795a1.2 1.2 0 0 1 0-1.7l1.326-1.325a1.2 1.2 0 0 1 1.7 0l5.338 5.351 12.408-15.9a1.2 1.2 0 0 1 1.686-.21L36.352 15a1.2 1.2 0 0 1 .211 1.687z"
}));

});


parcelRegister("bGuZT", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.execute = module.exports.default = void 0;

var $gyVEn = parcelRequire("gyVEn");

var $0231fe9a5a4eff1f$var$_PulseApiHelper = $l4FIw((parcelRequire("g3SqO")));

var $0231fe9a5a4eff1f$var$types = $0231fe9a5a4eff1f$var$_interopRequireWildcard((parcelRequire("je1Hc")));
function $0231fe9a5a4eff1f$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($0231fe9a5a4eff1f$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $0231fe9a5a4eff1f$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $0231fe9a5a4eff1f$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/ /**
 * The function will toggle the read status of
 * a particular notification and return if the status
 * is successful or not.
 * @param notification
 */ const $0231fe9a5a4eff1f$var$execute = (notification)=>async (dispatch)=>{
        dispatch({
            type: $0231fe9a5a4eff1f$var$types.TOGGLE_NOTIFICATION_READ_STATUS,
            payload: {
                id: notification.id
            }
        });
        const queryObject = $0231fe9a5a4eff1f$var$_PulseApiHelper.default.createANSResponseObject({
            ...notification,
            isRead: !notification.isRead
        });
        const { notification: notifications } = await (0, $gyVEn.updateNotifications)([
            queryObject
        ]);
        if (notifications.length !== 1) dispatch({
            type: $0231fe9a5a4eff1f$var$types.TOGGLE_NOTIFICATION_READ_STATUS,
            payload: {
                id: notification.id
            }
        });
        return notifications.length === 1;
    };
module.exports.execute = $0231fe9a5a4eff1f$var$execute;
var $0231fe9a5a4eff1f$var$_default = $0231fe9a5a4eff1f$var$execute;
module.exports.default = $0231fe9a5a4eff1f$var$_default;

});

parcelRegister("17UAX", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d22587b97e5c4bf$var$_react = $0d22587b97e5c4bf$var$_interopRequireWildcard((parcelRequire("7eprg")));

var $0d22587b97e5c4bf$var$_OverlayTrigger = $l4FIw((parcelRequire("aKT0j")));

var $0d22587b97e5c4bf$var$_Button = $l4FIw((parcelRequire("iNgWr")));

var $0d22587b97e5c4bf$var$_Clock = $l4FIw((parcelRequire("gyvPD")));

var $g9eLE = parcelRequire("g9eLE");

var $awzum = parcelRequire("awzum");

var $0d22587b97e5c4bf$var$_Tooltip = $l4FIw((parcelRequire("72PXO")));

var $0d22587b97e5c4bf$var$_PulseUtil = $l4FIw((parcelRequire("h9Sqk")));


var $a6smq = parcelRequire("a6smq");

var $2ljLL = parcelRequire("2ljLL");

var $1Rodh = parcelRequire("1Rodh");
function $0d22587b97e5c4bf$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($0d22587b97e5c4bf$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $0d22587b97e5c4bf$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $0d22587b97e5c4bf$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/ const $0d22587b97e5c4bf$var$RemindersDropDown = (props)=>{
    const trackEvent = (0, $2ljLL.useOmegaTrack)();
    const { isReminderActive: isReminderActive, reminderTime: reminderTime, onReminderDropDownOpen: onReminderDropDownOpen, onReminderDropDownClose: onReminderDropDownClose, onReminderDeleted: onReminderDeleted, intl: intl, onReminderSelected: onReminderSelected } = props;
    const { formatMessage: formatMessage } = intl;
    const formattedReminderTime = $0d22587b97e5c4bf$var$_PulseUtil.default.formatReminderTime(reminderTime);
    const [closeMenu, setCloseMenu] = (0, $0d22587b97e5c4bf$var$_react.useState)(false);
    const [isReminderEditInProgress, setReminderEditInProgress] = (0, $0d22587b97e5c4bf$var$_react.useState)(false);
    const showReminderEditMenu = isReminderActive && !isReminderEditInProgress;
    const selectionHandler = (args)=>{
        switch(args){
            case "Remind5Min":
                onReminderSelected($awzum.FIVE_MINUTES_IN_MILLISECONDS);
                setCloseMenu(true);
                break;
            case "Remind15Min":
                onReminderSelected($awzum.FIFTEEN_MINUTES_IN_MILLISECONDS);
                setCloseMenu(true);
                break;
            case "Remind60Min":
                onReminderSelected($awzum.SIXTY_MINUTES_IN_MILLISECONDS);
                setCloseMenu(true);
                break;
            case "Remind24Hr":
                onReminderSelected($awzum.TWENTY_FOUR_HOUR_IN_MILLISECONDS);
                setCloseMenu(true);
                break;
            case "editReminder":
                if (props.notificationId) trackEvent({
                    element: `${$1Rodh.ELEMENT_TYPES.BUTTON} - reminder edit button`,
                    action: $1Rodh.ACTION.CLICK,
                    feature: $1Rodh.FEATURE.NOTIFICATION_PAGE,
                    widget: $1Rodh.WIDGET_NAME.MESSAGE_FLOATING_ACTIONS,
                    widgetType: $1Rodh.WIDGET_TYPE.MENU_ITEM,
                    attributes: {
                        notificationId: props.notificationId
                    }
                });
                setReminderEditInProgress(true);
                break;
            case "deleteReminder":
                setCloseMenu(true);
                onReminderDeleted();
                break;
        }
    };
    return /*#__PURE__*/ $0d22587b97e5c4bf$var$_react.default.createElement($0d22587b97e5c4bf$var$_OverlayTrigger.default, {
        crossOffset: -20,
        delay: $awzum.TOOLTIP_DELAY_ON_ACTIONS_BUTTON,
        placement: "top",
        trigger: "hover"
    }, /*#__PURE__*/ $0d22587b97e5c4bf$var$_react.default.createElement("div", {
        className: "pulse-notification-message-actions-button"
    }, /*#__PURE__*/ $0d22587b97e5c4bf$var$_react.default.createElement($0d22587b97e5c4bf$var$_OverlayTrigger.default, {
        crossOffset: -100,
        disabled: closeMenu,
        onClick: (event)=>{
            event.stopPropagation();
            event.preventDefault();
        },
        onHide: onReminderDropDownClose,
        onShow: onReminderDropDownOpen,
        placement: "bottom",
        trigger: "click"
    }, /*#__PURE__*/ $0d22587b97e5c4bf$var$_react.default.createElement($0d22587b97e5c4bf$var$_Button.default, {
        className: "notification-snooze-button",
        icon: /*#__PURE__*/ $0d22587b97e5c4bf$var$_react.default.createElement($0d22587b97e5c4bf$var$_Clock.default, {
            size: "S"
        }),
        label: null,
        quiet: true,
        variant: "action"
    }), !showReminderEditMenu && /*#__PURE__*/ $0d22587b97e5c4bf$var$_react.default.createElement($g9eLE.Menu, {
        className: "pulse-reminder-dropdown-menu",
        onSelect: (args)=>selectionHandler(args)
    }, /*#__PURE__*/ $0d22587b97e5c4bf$var$_react.default.createElement($g9eLE.MenuItem, {
        value: "Remind5Min"
    }, formatMessage({
        id: "RemindMe5Min",
        defaultMessage: "Remind me in 5 Minutes",
        description: "Remind me in 5 Minutes"
    })), /*#__PURE__*/ $0d22587b97e5c4bf$var$_react.default.createElement($g9eLE.MenuItem, {
        value: "Remind15Min"
    }, formatMessage({
        id: "RemindMe15Min",
        defaultMessage: "Remind me in 15 Minutes",
        description: "Remind me in 15 Minutes"
    })), /*#__PURE__*/ $0d22587b97e5c4bf$var$_react.default.createElement($g9eLE.MenuItem, {
        value: "Remind60Min"
    }, formatMessage({
        id: "RemindMe60Min",
        defaultMessage: "Remind me in an Hour",
        description: "Remind me in an Hour"
    })), /*#__PURE__*/ $0d22587b97e5c4bf$var$_react.default.createElement($g9eLE.MenuItem, {
        value: "Remind24Hr"
    }, formatMessage({
        id: "RemindMeTomorrow",
        defaultMessage: "Remind me tomorrow",
        description: "Remind me tomorrow"
    }))), showReminderEditMenu && /*#__PURE__*/ $0d22587b97e5c4bf$var$_react.default.createElement($g9eLE.Menu, {
        className: "pulse-reminder-dropdown-menu",
        onSelect: (args)=>selectionHandler(args)
    }, /*#__PURE__*/ $0d22587b97e5c4bf$var$_react.default.createElement($g9eLE.MenuItem, {
        disabled: true
    }, formatMessage({
        id: "SetReminder",
        defaultMessage: "Reminder set for {formattedReminderTime}",
        description: "Set Reminder"
    }, {
        formattedReminderTime: formattedReminderTime
    })), /*#__PURE__*/ $0d22587b97e5c4bf$var$_react.default.createElement($g9eLE.MenuItem, {
        value: "editReminder"
    }, formatMessage({
        id: "EditReminder",
        defaultMessage: "Edit reminder",
        description: "Edit reminder"
    })), /*#__PURE__*/ $0d22587b97e5c4bf$var$_react.default.createElement($g9eLE.MenuItem, {
        value: "deleteReminder"
    }, formatMessage({
        id: "DeleteReminder",
        defaultMessage: "Delete reminder",
        description: "Delete reminder"
    }))))), /*#__PURE__*/ $0d22587b97e5c4bf$var$_react.default.createElement($0d22587b97e5c4bf$var$_Tooltip.default, null, isReminderActive ? formatMessage({
        id: "SetReminder",
        defaultMessage: "Reminder set for {formattedReminderTime}",
        description: "Set Reminder"
    }, {
        formattedReminderTime: formattedReminderTime
    }) : formatMessage({
        id: "Snooze",
        defaultMessage: "Snooze",
        description: "Snooze"
    })));
};
var $0d22587b97e5c4bf$var$_default = (0, $a6smq.default)($0d22587b97e5c4bf$var$RemindersDropDown);
module.exports.default = $0d22587b97e5c4bf$var$_default;

});
parcelRegister("gyvPD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c0d88371c25ef61b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $32iuA = parcelRequire("32iuA");
var $c0d88371c25ef61b$var$_Icon2 = $c0d88371c25ef61b$var$_interopRequireDefault($32iuA);

var $7eprg = parcelRequire("7eprg");
var $c0d88371c25ef61b$var$_react2 = $c0d88371c25ef61b$var$_interopRequireDefault($7eprg);
function $c0d88371c25ef61b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}


var $c0d88371c25ef61b$var$WrappedIcon = function WrappedIcon(props) {
    return $c0d88371c25ef61b$var$_react2.default.createElement($c0d88371c25ef61b$var$_Icon2.default, $c0d88371c25ef61b$var$_extends({}, props, {
        icon: {
            18: (parcelRequire("bT6Wa")),
            24: (parcelRequire("9n1Ph"))
        }
    }));
};
$c0d88371c25ef61b$var$WrappedIcon.displayName = "Clock";
module.exports.default = $c0d88371c25ef61b$var$WrappedIcon;

});
parcelRegister("bT6Wa", function(module, exports) {
"use strict";

var $7eprg = parcelRequire("7eprg");
module.exports = $7eprg.createElement("svg", {
    viewBox: "0 0 36 36"
}, $7eprg.createElement("path", {
    d: "M18 2a16 16 0 1 0 16 16A16 16 0 0 0 18 2zm0 30a14 14 0 1 1 14-14 14 14 0 0 1-14 14z"
}), $7eprg.createElement("path", {
    d: "M20 16.086V7a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v10.586a1 1 0 0 0 .293.707L21.9 23.9a1 1 0 0 0 1.414 0l1.336-1.336a1 1 0 0 0 0-1.414l-4.357-4.357a1 1 0 0 1-.293-.707z"
}));

});

parcelRegister("9n1Ph", function(module, exports) {
"use strict";

var $7eprg = parcelRequire("7eprg");
module.exports = $7eprg.createElement("svg", {
    viewBox: "0 0 48 48"
}, $7eprg.createElement("path", {
    d: "M26 22.086V11a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v12.586a1 1 0 0 0 .293.707l6.3 6.3a1 1 0 0 0 1.414 0l1.336-1.336a1 1 0 0 0 0-1.414l-5.054-5.054a1 1 0 0 1-.289-.703z"
}), $7eprg.createElement("path", {
    d: "M24 7.8A16.2 16.2 0 1 1 7.8 24 16.219 16.219 0 0 1 24 7.8zM24 4a20 20 0 1 0 20 20A20 20 0 0 0 24 4z"
}));

});


parcelRegister("a6smq", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return $75b076c4a1839870$export$2881499e37b75b9a; });
$parcel$export(module.exports, "Context", function () { return $75b076c4a1839870$export$841858b892ce1f4c; });
$parcel$export(module.exports, "default", function () { return $75b076c4a1839870$export$2e2bcd8739ae039; });

var $2bLxa = parcelRequire("2bLxa");

var $7eprg = parcelRequire("7eprg");

var $gnqGG = parcelRequire("gnqGG");

var $kRaZB = parcelRequire("kRaZB");
function $75b076c4a1839870$var$getDisplayName(Component) {
    return Component.displayName || Component.name || "Component";
}
// TODO: We should provide initial value here
var $75b076c4a1839870$var$IntlContext = $7eprg.createContext(null);
var $75b076c4a1839870$var$IntlConsumer = $75b076c4a1839870$var$IntlContext.Consumer, $75b076c4a1839870$var$IntlProvider = $75b076c4a1839870$var$IntlContext.Provider;
var $75b076c4a1839870$export$2881499e37b75b9a = $75b076c4a1839870$var$IntlProvider;
var $75b076c4a1839870$export$841858b892ce1f4c = $75b076c4a1839870$var$IntlContext;
function $75b076c4a1839870$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? "intl" : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $7eprg.createElement($75b076c4a1839870$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $kRaZB.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $7eprg.createElement(WrappedComponent, (0, $2bLxa.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($75b076c4a1839870$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($gnqGG)))($7eprg.forwardRef(function(props, ref) {
        return $7eprg.createElement(WithIntl, (0, $2bLxa.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gnqGG)))(WithIntl, WrappedComponent);
}

});
parcelRegister("kRaZB", function(module, exports) {

$parcel$export(module.exports, "invariantIntlContext", function () { return $f2f148c56a407f65$export$45c4bbf6e55bba1f; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $f2f148c56a407f65$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "assignUniqueKeysToParts", function () { return $f2f148c56a407f65$export$cfec03d26465fa63; });
$parcel$export(module.exports, "shallowEqual", function () { return $f2f148c56a407f65$export$d36bdfa510afb180; });

var $2bLxa = parcelRequire("2bLxa");

var $7eprg = parcelRequire("7eprg");

var $PuMwh = parcelRequire("PuMwh");

var $cOQoo = parcelRequire("cOQoo");
function $f2f148c56a407f65$export$45c4bbf6e55bba1f(intl) {
    (0, $PuMwh.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $f2f148c56a407f65$export$b52f8d6fc0d47415 = (0, $2bLxa.__assign)((0, $2bLxa.__assign)({}, (0, $cOQoo.DEFAULT_INTL_CONFIG)), {
    textComponent: $7eprg.Fragment
});
function $f2f148c56a407f65$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($7eprg.Children.toArray(parts));
    };
}
function $f2f148c56a407f65$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});


parcelRegister("2ljLL", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useOmegaEvent = $1b4ce0b4f34f9c13$var$useOmegaEvent;
module.exports.useOmegaTrack = $1b4ce0b4f34f9c13$var$useOmegaTrack;

var $jyNBE = parcelRequire("jyNBE");

var $7eprg = parcelRequire("7eprg");

var $1b4ce0b4f34f9c13$var$_metrics = $l4FIw((parcelRequire("2uDvu")));
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/ function $1b4ce0b4f34f9c13$var$useOmegaEvent() {
    const elementRef = (0, $7eprg.useRef)(null);
    // works like a event handler
    function trackEvent(options) {
        const { element: element } = options;
        if (options.attributes) options.attributes = $1b4ce0b4f34f9c13$var$normaliseAttributes(options.attributes);
        return (0, $jyNBE.sendOmegaEvent)(element, elementRef, options);
    }
    return {
        trackEvent: trackEvent,
        ref: elementRef
    };
}
function $1b4ce0b4f34f9c13$var$normaliseAttributes(attributes) {
    const result = {};
    Object.keys(attributes).forEach((k)=>{
        result[k.toLowerCase()] = attributes[k];
    });
    return result;
}
function $1b4ce0b4f34f9c13$var$useOmegaTrack() {
    const metrics = (0, $1b4ce0b4f34f9c13$var$_metrics.default)("exc.pulse");
    return (payload)=>{
        const { elementType: elementType, ...options } = payload;
        const { action: action, attributes: attributes, widget: widget, widgetType: widgetType, feature: feature, element: element } = options;
        const finalPayload = {
            action: action || "click",
            element: element,
            feature: feature,
            type: payload.elementType,
            widget: {
                name: widget,
                type: widgetType || elementType
            },
            attributes: attributes ? $1b4ce0b4f34f9c13$var$normaliseAttributes(attributes) : undefined
        };
        metrics.analytics && metrics.analytics.trackEvent(finalPayload);
    };
}

});
parcelRegister("jyNBE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.filterOmegaProps = module.exports.getOmegaEvent = module.exports.sendOmegaEvent = module.exports.trackOmega = void 0;

var $hJLtl = parcelRequire("hJLtl");
Object.defineProperty(module.exports, "trackOmega", {
    enumerable: true,
    get: function() {
        return $hJLtl.trackOmega;
    }
});

var $ahBjN = parcelRequire("ahBjN");
Object.defineProperty(module.exports, "sendOmegaEvent", {
    enumerable: true,
    get: function() {
        return $ahBjN.sendOmegaEvent;
    }
});
/**
 * Generates an object of omega event data.
 * @param data Omega event data.
 * @param data.attributes Optional list of attributes.
 * @param data.element The name or label of the element acted upon.
 * @param data.event The event.
 * @param data.feature The feature.
 * @param data.search Optional search.
 * @param data.type The type.
 * @param data.widget The widget, a subset of the feature.
 * @returns Correctly formatted object of event information.
 */ function $e3d7ac11924c2f86$var$getOmegaEvent(_a) {
    var action = _a.action, attributes = _a.attributes, element = _a.element, event = _a.event, feature = _a.feature, search = _a.search, type = _a.type, widget = _a.widget;
    action = action || event && event.type;
    type = type || event && event.target && event.target.nodeName.toLowerCase();
    feature = feature || "shell header";
    widget = widget || {
        name: element,
        type: type
    };
    var eventData = {
        action: action,
        attributes: attributes,
        element: element,
        feature: feature,
        search: search,
        type: type,
        widget: widget
    };
    if (!eventData.attributes) delete eventData.attributes;
    if (!eventData.search) delete eventData.search;
    return eventData;
}
module.exports.getOmegaEvent = $e3d7ac11924c2f86$var$getOmegaEvent;
/**
 * Filter props to only include specific Omega properties. This function is only used
 * in cases where users want to pass data-omega-feature, data-omega-widget and
 * data-omega-widget-type to override the default omega attributes added by Quarry or
 * other components having default omega attributes. It can also be used to filter
 * default omega props passed to components, or to pass other attributes such as
 * data-omega-attribute-* and data-omega-action. This function does not retain
 * the element and action omega attributes as they do not support default values.
 * @param props - An object containing any props.
 * @returns An object containing only the props that have Omega properties.
 */ var $e3d7ac11924c2f86$var$filterOmegaProps = function(props) {
    var omegaProps = {};
    Object.entries(props).forEach(function(_a) {
        var key = _a[0], value = _a[1];
        if ([
            "data-omega-feature",
            "data-omega-feature-default",
            "data-omega-widget",
            "data-omega-widget-default",
            "data-omega-widget-type",
            "data-omega-widget-type-default",
            "data-omega-action"
        ].includes(key) || key.startsWith("data-omega-attribute-")) omegaProps[key] = value;
    });
    return omegaProps;
};
module.exports.filterOmegaProps = $e3d7ac11924c2f86$var$filterOmegaProps;

});
parcelRegister("hJLtl", function(module, exports) {
"use strict";
var $ce9b76a08c851d43$var$__assign = module.exports && module.exports.__assign || function() {
    $ce9b76a08c851d43$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ce9b76a08c851d43$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.trackOmega = void 0;
/**
 * Creates list of attributes to be included in omega payload.
 */ var $ce9b76a08c851d43$var$getAttributes = function(element) {
    var currentElement = element;
    var attributes = {
        url: window.location.href // eslint-disable-line
    };
    while(currentElement){
        var dataAttrs = Object.values(currentElement.attributes);
        Object.values(dataAttrs).forEach(function(_a) {
            var nodeName = _a.nodeName, nodeValue = _a.nodeValue;
            if (nodeName.startsWith("data-omega-attribute-") && nodeValue) {
                var attrName = nodeName.replace("data-omega-attribute-", "");
                attributes[attrName] = nodeValue;
            }
        });
        if (currentElement.hasAttribute("data-omega-feature") || currentElement.hasAttribute("data-omega-feature-default")) break;
        currentElement = currentElement.parentElement;
    }
    // add default attributes
    var defaultFeature = $ce9b76a08c851d43$var$getClosestAttribute(element, "data-omega-feature-default");
    var defaultWidget = $ce9b76a08c851d43$var$getClosestAttribute(element, "data-omega-widget-default");
    var defaultWidgetType = $ce9b76a08c851d43$var$getClosestAttribute(element, "data-omega-widget-type-default");
    if (defaultFeature) attributes.defaultFeature = defaultFeature;
    if (defaultWidget) attributes.defaultWidget = defaultWidget;
    if (defaultWidgetType) attributes.defaultWidgetType = defaultWidgetType;
    return {
        attributes: attributes
    };
};
/**
 * Gets closest parent with omega props if the target of the click
 * is not the element with omega props.
 */ var $ce9b76a08c851d43$var$getAdjustedTarget = function(element) {
    var omegaElement = element.closest("[data-omega-element]");
    return omegaElement ? omegaElement : element;
};
/**
 * Gets closest parent with the specific omega attribute and returns the value
 * of that attribute if found.
 */ var $ce9b76a08c851d43$var$getHigherAttribute = function(element, attr) {
    var omegaElement = element.closest("[".concat(attr, "]"));
    if (omegaElement) return omegaElement.getAttribute(attr);
};
/**
 * Checks for data attribute on the element. If it doesn't exist, checks up the
 * dom tree to find it.
 */ var $ce9b76a08c851d43$var$getClosestAttribute = function(element, attr) {
    return element.getAttribute(attr) || $ce9b76a08c851d43$var$getHigherAttribute(element, attr);
};
/**
 * Sends an event to OMEGA.
 */ var $ce9b76a08c851d43$var$processEvent = function(targetElement, metrics, debugOn, win) {
    // If the element does not have an element attribute, it is not a valid omega annotation.
    var element = targetElement.getAttribute("data-omega-element");
    if (element) {
        // check for feature
        var feature = $ce9b76a08c851d43$var$getClosestAttribute(targetElement, "data-omega-feature") || $ce9b76a08c851d43$var$getClosestAttribute(targetElement, "data-omega-feature-default");
        // check for widget name
        var widgetName = $ce9b76a08c851d43$var$getClosestAttribute(targetElement, "data-omega-widget") || $ce9b76a08c851d43$var$getClosestAttribute(targetElement, "data-omega-widget-default");
        // check for widget type
        var widgetType = $ce9b76a08c851d43$var$getClosestAttribute(targetElement, "data-omega-widget-type") || $ce9b76a08c851d43$var$getClosestAttribute(targetElement, "data-omega-widget-type-default");
        if (feature && widgetName) {
            // Optional Values
            var customAction = targetElement.getAttribute("data-omega-action");
            var type = targetElement.nodeName.toLowerCase();
            var attributes = $ce9b76a08c851d43$var$getAttributes(targetElement);
            var payload = $ce9b76a08c851d43$var$__assign({
                action: customAction || "click",
                element: element,
                feature: feature,
                type: type,
                widget: {
                    name: widgetName,
                    type: widgetType || type
                }
            }, attributes);
            metrics.analytics.trackEvent(payload);
            // If the debugging query param is present, console the payload
            if (debugOn) console.log(payload); // eslint-disable-line
        }
    }
};
/**
 * Handles events of type 'omega-event', 'pointerup' and 'keydown'.
 * Ensures that Omega event is only sent once for 'omega-event' when a single action
 * triggers multiple events ('omega-event' along with 'pointerup' or 'keydown').
 */ var $ce9b76a08c851d43$var$handleEventFn = function(e, metrics, debugOn, win) {
    if (e.type === "keydown" && e.key !== "Enter") return;
    // instanceof must check against the correct global context.
    if (!(e.target instanceof win.HTMLElement)) return;
    var targetElement = e.target;
    // Sometimes the target element is a child of the omega annotated element.
    if (!targetElement.getAttribute("data-omega-element")) targetElement = $ce9b76a08c851d43$var$getAdjustedTarget(targetElement);
    // Prevent duplicate event handling ('omega-event' takes precedence over other event types)
    if (e.type === "omega-event") {
        // Add a flag attribute to target element to indicate that the 'omega-event' has been handled.
        targetElement.setAttribute("data-omega-handled", "true");
        $ce9b76a08c851d43$var$processEvent(targetElement, metrics, debugOn, win);
    } else // Defer execution when event type is 'pointerup' or 'keydown'
    return win.requestAnimationFrame(function() {
        if (targetElement.getAttribute("data-omega-handled") !== "true") $ce9b76a08c851d43$var$processEvent(targetElement, metrics, debugOn, win);
        else targetElement.removeAttribute("data-omega-handled");
    });
};
// eslint-disable-next-line no-restricted-globals
function $ce9b76a08c851d43$var$trackOmega(name, win, debugOn, newMetrics) {
    if (name === void 0) name = "exc.omega";
    if (win === void 0) win = window;
    if (debugOn === void 0) debugOn = false;
    var metricsApi = (win["exc-module-runtime"] || {}).metrics;
    if (!newMetrics && !metricsApi) throw new Error("Cannot access the Metrics SDK");
    var metrics = newMetrics || metricsApi.create(name);
    var handleEvent = function(e) {
        return $ce9b76a08c851d43$var$handleEventFn(e, metrics, debugOn, win);
    };
    win.addEventListener("omega-event", handleEvent, {
        capture: true
    });
    win.addEventListener("pointerup", handleEvent, {
        capture: true
    });
    win.addEventListener("keydown", handleEvent, {
        capture: true
    });
}
module.exports.trackOmega = $ce9b76a08c851d43$var$trackOmega;

});

parcelRegister("ahBjN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sendOmegaEvent = void 0;

var $9fbEW = parcelRequire("9fbEW");

var $3qco7 = parcelRequire("3qco7");
/**
 * sendOmegaEvent - A higher-order function that wraps a given event handler function
 *                  to add omega attributes and handle custom omega events. If a handler
 *                  is not provided, the function still adds omega attributes to the target element.
 * @param {string} elementName - The name of the element (e.g., button) or the group name for
 * collection components (e.g., Menu, ActionGroup, ListBox). `elementName` will be used as the base
 * value for the `data-omega-element` attribute. The final attribute value depends on the type of the
 * argument passed to the event handler, representing the type of event or the selected
 * data (`Event`, `DateValue`, `RangeValue`, etc).
 * - For `Event` types, `elementName` is used directly: `data-omega-element="<elementName>"`
 * - For other types, selections are appended to `elementName` inside square brackets. For example,
 * a `DateValue` would result in `data-omega-element="<elementName> [<year>_<month>_<day>]"`,
 * a `RangeValue` would transform into `data-omega-element="<elementName> [<startValue>,<endValue>]"`.
 * Other event types are handled in a similar fashion.
 * @param {React.RefObject<{UNSAFE_getDOMNode?: () => HTMLElement}> | null} ref - A reference object created
 * using React's useRef hook. For handlers passing an `Event` to the callback, `ref` can be `null`, as the target
 * element can be derived from the `Event` object (e.g., Button). In all other cases, `ref` should be provided
 * as it is essential for identifying the target element that will receive the Omega attributes
 * (e.g., Menu, ActionGroup, ListBox, Calendar, RangeSlider etc).
 * @param {object} [options] - An optional object containing additional options.
 * @property {function} [options.onEvent] - The event handler function to be wrapped (optional).
 * @property {string} [options.action] - An optional action value for the `data-omega-action` attribute.
 * @property {string} [options.feature] - An optional feature value for the `data-omega-feature` attribute.
 * @property {string} [options.widget] - An optional widget value for the `data-omega-widget` attribute.
 * @property {string} [options.widgetType] - An optional widget value for the `data-omega-widget-type` attribute.
 * @property {string} [options.attributes] - An optional attributes object containing `key-value` pairs to be used
 * for the `data-omega-attribute-*` attributes. For instance, if `attributes: {version: "beta"}` is passed, then
 * `sendOmegaEvent` will set`data-omega-attribute-version="beta"` to the target element.
 * @property {boolean} [options.debug] - A flag indicating whether debug information should be printed to the console.
 *
 * @example
 * ```typescript
 * // With a React Spectrum button or a regular button
 * <Button
 *   variant="cta"
 *   onPress={sendOmegaEvent("open", null, {onEvent: onPressHandler,action: "display"})}
 * >
 *   Open
 * </Button>;
 *
 * // With an ActionGroup collection component
 * const actionGroupRef = useRef(null);
 * const items = [
 *   { label: "React", name: "react" },
 *   { label: "Add", name: "add"},
 *   { label: "Delete", name: "delete" },
 * ];
 *
 * <ActionGroup
 *   items={items}
 *   onAction={sendOmegaEvent("group links", actionGroupRef, {onEvent: onActionHandler})}
 *   ref={actionGroupRef}
 *   overflowMode="collapse"
 * >
 *   {(item) => <Item key={item.name}>{item.label}</Item>}
 * </ActionGroup>;
 *
 * // With a Menu collection component
 * const menuRef = useRef(null);
 * const menuItems = [
 *   { label: "Add", name: "add"},
 *   { label: "Delete", name: "delete"},
 * ];
 *
 * <MenuTrigger>
 *   <Button variant="cta" onPress={sendOmegaEvent("open", null)}>
 *      Open Menu
 *   </Button>
 *   <Menu
 *     items={menuItems}
 *     onAction={sendOmegaEvent("menu links", menuRef, {feature: "menu", widget: "menu widget"})}
 *     ref={menuRef}
 *   >
 *     {(item) => <MenuItem key={item.name}>{item.label}</MenuItem>}
 *   </Menu>
 * </MenuTrigger>;
 *
 * // With a ListBox collection component with multiple selection
 * const listBoxRef = useRef(null);
 * const handleSelection = (keys) => {
 *     setSelectedKeys(keys);
 * };
 *
 * <ListBox
 *   aria-label="Example with onSelectionChange"
 *   selectionMode="multiple"
 *   onSelectionChange={sendOmegaEvent("listbox items", listBoxRef, {onEvent: handleSelection})}
 *   selectedKeys={selectedKeys}
 *   ref={listBoxRef}
 * >
 *   <Item key="one">One</Item>
 *   <Item key="two">Two</Item>
 *   <Item key="three">Three</Item>
 * </ListBox>;
 *
 * // With a RangeSlider component
 * const sliderRef = useRef(null);
 *
 * <RangeSlider
 *   label="Range"
 *   onChangeEnd={sendOmegaEvent("slider", sliderRef, {onEvent: onChangeHandler}
 *   defaultValue={{ start: 12, end: 36 }}
 *   ref={sliderRef}
 * />
 *
 * // With a Calendar component
 * const dateRef = useRef(null);
 *
 * <Calendar
 *   aria-label="Event date"
 *   onChange={sendOmegaEvent("calendar", dateRef, {onEvent: onChangeHandler}}
 *   ref={dateRef}
 * />
 *```
 */ var $77c8708b9d541947$var$sendOmegaEvent = function(elementName, ref, options) {
    if (ref === void 0) ref = null;
    if (options === void 0) options = {};
    var // eslint-disable-next-line @typescript-eslint/no-empty-function
    _a = options.onEvent, // eslint-disable-next-line @typescript-eslint/no-empty-function
    onEvent = _a === void 0 ? function() {} : _a, action = options.action, feature = options.feature, widget = options.widget, widgetType = options.widgetType, _b = options.attributes, attributes = _b === void 0 ? {} : _b, _c = options.debug, debug = _c === void 0 ? false : _c;
    var customHandler = function(eventData) {
        var target = null;
        var omegaElement = "";
        var handlers = [
            {
                handler: $3qco7.handleTime,
                test: $3qco7.isTime
            },
            {
                handler: $3qco7.handleDateRange,
                test: $3qco7.isDateRange
            },
            {
                handler: $3qco7.handleDate,
                test: $3qco7.isDate
            },
            {
                handler: $3qco7.handleRange,
                test: $3qco7.isRange
            },
            {
                handler: $3qco7.handleBoolean,
                test: $3qco7.isBool
            }
        ];
        for(var _i = 0, handlers_1 = handlers; _i < handlers_1.length; _i++){
            var _a = handlers_1[_i], test_1 = _a.test, handler = _a.handler;
            if (test_1(eventData)) {
                omegaElement = handler(elementName, eventData);
                break;
            }
        }
        if (!omegaElement) {
            if (eventData == null) // When eventData is not defined or empty
            omegaElement = elementName;
            else if (Array.isArray(eventData) || eventData instanceof Set) {
                // For components with multiple selection (e.g., ListBox, CheckboxGroup)
                var selectedItems = Array.from(eventData);
                omegaElement = selectedItems.length > 0 ? "".concat(elementName, " [").concat(selectedItems, "]") : elementName;
            } else if (typeof eventData === "string" || typeof eventData === "number") // For components where eventData is a string or number (e.g., Menu, ActionGroup, Slider)
            omegaElement = "".concat(elementName, " [").concat(eventData, "]");
            else if ("target" in eventData) {
                // For components where eventData is an Event (e.g., Button)
                omegaElement = elementName;
                target = eventData.target;
            } else if (debug) {
                console.error("Error: event type passed to callback is not supported."); // eslint-disable-line
                return;
            }
        }
        // Determine the target for the Omega attributes if not defined yet
        if (!target && ref && ref.current) target = ref.current.UNSAFE_getDOMNode ? ref.current.UNSAFE_getDOMNode() : null;
        if (!target && debug) {
            console.error("Error: ref or ref.current is not defined or UNSAFE_getDOMNode is missing"); // eslint-disable-line
            return;
        }
        if (target) {
            // add omega attributes to target element
            target.setAttribute("data-omega-element", omegaElement);
            action && target.setAttribute("data-omega-action", action);
            feature && target.setAttribute("data-omega-feature", feature);
            widget && target.setAttribute("data-omega-widget", widget);
            widgetType && target.setAttribute("data-omega-widget-type", widgetType);
            for(var key in attributes)target.setAttribute("data-omega-attribute-".concat(key), attributes[key]);
            target.setAttribute("data-omega-attribute-omegahandler", "true");
            // create and dispatch custom omega event
            var omegaEvent = new CustomEvent("omega-event");
            target.dispatchEvent(omegaEvent);
            if (debug) console.log("Target element with Omega annotations: ", target); // eslint-disable-line
        }
    };
    return (0, $9fbEW.chain)(customHandler, onEvent);
};
module.exports.sendOmegaEvent = $77c8708b9d541947$var$sendOmegaEvent;

});
parcelRegister("9fbEW", function(module, exports) {

$parcel$export(module.exports, "chain", function () { return $6bae8f0f72016389$export$e08e3b67e392101e; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Calls all functions in the order they were chained with the same arguments.
 */ function $6bae8f0f72016389$export$e08e3b67e392101e(...callbacks) {
    return (...args)=>{
        for (let callback of callbacks)if (typeof callback === "function") callback(...args);
    };
}

});

parcelRegister("3qco7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.handleBoolean = module.exports.handleRange = module.exports.handleDate = module.exports.handleDateRange = module.exports.handleTime = module.exports.isTime = module.exports.isDateRange = module.exports.isDate = module.exports.isRange = module.exports.isBool = void 0;
var $27dd68d4096921cb$var$hasProperties = function(obj, props) {
    return typeof obj === "object" && props.every(function(prop) {
        return prop in obj;
    });
};
var $27dd68d4096921cb$var$isBool = function(obj) {
    return typeof obj === "boolean";
};
module.exports.isBool = $27dd68d4096921cb$var$isBool;
var $27dd68d4096921cb$var$isRange = function(obj) {
    return $27dd68d4096921cb$var$hasProperties(obj, [
        "start",
        "end"
    ]);
};
module.exports.isRange = $27dd68d4096921cb$var$isRange;
var $27dd68d4096921cb$var$isDate = function(obj) {
    return $27dd68d4096921cb$var$hasProperties(obj, [
        "year",
        "month",
        "day"
    ]);
};
module.exports.isDate = $27dd68d4096921cb$var$isDate;
var $27dd68d4096921cb$var$isDateRange = function(obj) {
    return $27dd68d4096921cb$var$hasProperties(obj, [
        "start",
        "end"
    ]) && (0, module.exports.isDate)(obj.start) && (0, module.exports.isDate)(obj.end);
};
module.exports.isDateRange = $27dd68d4096921cb$var$isDateRange;
var $27dd68d4096921cb$var$isTime = function(obj) {
    return $27dd68d4096921cb$var$hasProperties(obj, [
        "hour",
        "minute",
        "second"
    ]);
};
module.exports.isTime = $27dd68d4096921cb$var$isTime;
/**
 * Handler functions to generate `omegaElement` strings based on the type of data received.
 * Different handlers are used depending on the type of component.
 */ // For Time components (e.g., Timefield)
var $27dd68d4096921cb$var$handleTime = function(elementName, time) {
    return "".concat(elementName, " [").concat(time.hour, "_").concat(time.minute, "_").concat(time.second, "]");
};
module.exports.handleTime = $27dd68d4096921cb$var$handleTime;
// For Date Range components (e.g., DateRangePicker)
var $27dd68d4096921cb$var$handleDateRange = function(elementName, range) {
    return "".concat(elementName, " [").concat(range.start.year, "_").concat(range.start.month, "_").concat(range.start.day, ",").concat(range.end.year, "_").concat(range.end.month, "_").concat(range.end.day, "]");
};
module.exports.handleDateRange = $27dd68d4096921cb$var$handleDateRange;
// For Date components (e.g., Calendar, DatePicker)
var $27dd68d4096921cb$var$handleDate = function(elementName, date) {
    return "".concat(elementName, " [").concat(date.year, "_").concat(date.month, "_").concat(date.day, "]");
};
module.exports.handleDate = $27dd68d4096921cb$var$handleDate;
// For Range components (e.g., RangeSlider)
var $27dd68d4096921cb$var$handleRange = function(elementName, range) {
    return "".concat(elementName, " [").concat(range.start, ",").concat(range.end, "]");
};
module.exports.handleRange = $27dd68d4096921cb$var$handleRange;
// For Boolean components (e.g., Checkbox, Switch)
var $27dd68d4096921cb$var$handleBoolean = function(elementName, bool) {
    return bool ? "".concat(elementName, " [selected]") : "".concat(elementName, " [deselected]");
};
module.exports.handleBoolean = $27dd68d4096921cb$var$handleBoolean;

});




parcelRegister("1Rodh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WIDGET_TYPE = module.exports.WIDGET_NAME = module.exports.FEATURE = module.exports.ELEMENT_TYPES = module.exports.ELEMENT_NAME = module.exports.ACTION = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/ let $15ad85eaa24c9a60$var$FEATURE = /*#__PURE__*/ function(FEATURE) {
    FEATURE["NOTIFICATION_PAGE"] = "notification-page";
    FEATURE["ANNOUNCEMENT_PAGE"] = "announcement-page";
    FEATURE["NOTIFICATION_FLYOUT"] = "notification-flyout";
    return FEATURE;
}({});
module.exports.FEATURE = $15ad85eaa24c9a60$var$FEATURE;
let $15ad85eaa24c9a60$var$WIDGET_NAME = /*#__PURE__*/ function(WIDGET_NAME) {
    WIDGET_NAME["NOTIFICATIONS_TAB"] = "notifications-tab";
    WIDGET_NAME["MARK_ALL_AS_READ"] = "mark-all-as-read";
    WIDGET_NAME["EDIT_PREFERENCE"] = "edit-preference";
    WIDGET_NAME["NOTIFICATION_MESSAGE"] = "notification-message";
    WIDGET_NAME["MESSAGE_FLOATING_ACTIONS"] = "message-floating-actions";
    WIDGET_NAME["NOTIFICATIONS_TAB_GROUP"] = "notifications-tab-group";
    WIDGET_NAME["LEFT_RAIL_FILTERS"] = "left-rail-filters";
    return WIDGET_NAME;
}({});
module.exports.WIDGET_NAME = $15ad85eaa24c9a60$var$WIDGET_NAME;
let $15ad85eaa24c9a60$var$WIDGET_TYPE = /*#__PURE__*/ function(WIDGET_TYPE) {
    WIDGET_TYPE["TAB"] = "tab";
    WIDGET_TYPE["BUTTON"] = "button";
    WIDGET_TYPE["CHECKBOX"] = "checkbox";
    WIDGET_TYPE["LINK"] = "link";
    WIDGET_TYPE["MENU_ITEM"] = "menu-item";
    WIDGET_TYPE["CHECKBOX_GROUP"] = "checkbox-group";
    WIDGET_TYPE["PICKER"] = "picker";
    WIDGET_TYPE["TAB_GROUP"] = "tab-group";
    WIDGET_TYPE["SWITCH"] = "switch";
    WIDGET_TYPE["NUMBER_FIELD"] = "number-field";
    WIDGET_TYPE["RADIO_GROUP"] = "radio-group";
    WIDGET_TYPE["INLINE_ALERT"] = "inline-alert";
    WIDGET_TYPE["VIEW"] = "view";
    return WIDGET_TYPE;
}({});
module.exports.WIDGET_TYPE = $15ad85eaa24c9a60$var$WIDGET_TYPE;
let $15ad85eaa24c9a60$var$ELEMENT_NAME = /*#__PURE__*/ function(ELEMENT_NAME) {
    ELEMENT_NAME["VIEW_ALL_NOTIFICATION_FILTERS"] = "view-all-notification-filters";
    ELEMENT_NAME["ADOBE_STATUS_LINK"] = "adobe-status-link";
    ELEMENT_NAME["MARK_AS_READ_BUTTON"] = "mark as read button";
    ELEMENT_NAME["MARK_ALL_AS_READ_BUTTON"] = "mark all as read button";
    ELEMENT_NAME["VIEW_ALL_BUTTON"] = "view all button";
    return ELEMENT_NAME;
}({});
module.exports.ELEMENT_NAME = $15ad85eaa24c9a60$var$ELEMENT_NAME;
let $15ad85eaa24c9a60$var$ACTION = /*#__PURE__*/ function(ACTION) {
    ACTION["CLICK"] = "click";
    ACTION["SELECT"] = "select";
    ACTION["CHANGE"] = "change";
    return ACTION;
}({});
module.exports.ACTION = $15ad85eaa24c9a60$var$ACTION;
let $15ad85eaa24c9a60$var$ELEMENT_TYPES = /*#__PURE__*/ function(ELEMENT_TYPES) {
    ELEMENT_TYPES["TAB_LIST"] = "tab-list";
    ELEMENT_TYPES["INPUT"] = "input";
    ELEMENT_TYPES["MENU"] = "menu";
    ELEMENT_TYPES["BUTTON"] = "button";
    ELEMENT_TYPES["CHECKBOX"] = "checkbox";
    ELEMENT_TYPES["LINK"] = "link";
    return ELEMENT_TYPES;
}({});
module.exports.ELEMENT_TYPES = $15ad85eaa24c9a60$var$ELEMENT_TYPES;

});


parcelRegister("kuUz8", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eec27cbb82427ee9$var$_react = $l4FIw((parcelRequire("7eprg")));

var $eec27cbb82427ee9$var$_AdobeSocialColorLight = $l4FIw((parcelRequire("eQyUc")));

var $eec27cbb82427ee9$var$_CircleExperienceCloud = $l4FIw((parcelRequire("70Cv3")));

var $eec27cbb82427ee9$var$AnnouncementSelectors = $eec27cbb82427ee9$var$_interopRequireWildcard((parcelRequire("iG8eA")));

var $eec27cbb82427ee9$var$_store = $l4FIw((parcelRequire("59XPv")));
function $eec27cbb82427ee9$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($eec27cbb82427ee9$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $eec27cbb82427ee9$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $eec27cbb82427ee9$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/ const $eec27cbb82427ee9$var$SolutionIcon = (props)=>{
    const { product: product } = props;
    const userEntitlements = $eec27cbb82427ee9$var$AnnouncementSelectors.getUserEntitlements($eec27cbb82427ee9$var$_store.default.getState());
    //Show default icon ExerienceCloud for announcement and notifications
    let productIcon = /*#__PURE__*/ $eec27cbb82427ee9$var$_react.default.createElement("img", {
        alt: product,
        src: $eec27cbb82427ee9$var$_CircleExperienceCloud.default
    });
    for (const userEntitlement of userEntitlements){
        let skip = false;
        if (product === userEntitlement.name || product === userEntitlement.longName && !skip && userEntitlement.functionalIconUrl) {
            skip = true;
            productIcon = /*#__PURE__*/ $eec27cbb82427ee9$var$_react.default.createElement("img", {
                alt: userEntitlement.name,
                src: userEntitlement.functionalIconUrl
            });
        }
    }
    //TODO remove once Social Product is deprecated
    if (product === "Social") productIcon = /*#__PURE__*/ $eec27cbb82427ee9$var$_react.default.createElement($eec27cbb82427ee9$var$_AdobeSocialColorLight.default, {
        className: "pulse-announcement-solution-icon",
        size: "L"
    });
    return productIcon;
};
var $eec27cbb82427ee9$var$_default = $eec27cbb82427ee9$var$SolutionIcon;
module.exports.default = $eec27cbb82427ee9$var$_default;

});
parcelRegister("eQyUc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $32iuA = parcelRequire("32iuA");
var $acf0ff7f21bca477$var$_Icon2 = $acf0ff7f21bca477$var$_interopRequireDefault($32iuA);

var $7eprg = parcelRequire("7eprg");
var $acf0ff7f21bca477$var$_react2 = $acf0ff7f21bca477$var$_interopRequireDefault($7eprg);
function $acf0ff7f21bca477$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $acf0ff7f21bca477$var$WrappedIcon = function WrappedIcon(props) {
    return $acf0ff7f21bca477$var$_react2.default.createElement($acf0ff7f21bca477$var$_Icon2.default, props, $acf0ff7f21bca477$var$_react2.default.createElement("svg", {
        viewBox: "0 0 1152 1152"
    }, $acf0ff7f21bca477$var$_react2.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FF179C",
        d: "M0 576c0 318.1 257.9 576 576 576s576-257.9 576-576S894.1 0 576 0 0 257.9 0 576zm59.4 0C59.4 290.3 290.7 58.8 576 58.8s516.6 231.6 516.6 517.2-231.3 517.2-516.6 517.2S59.4 861.7 59.4 576z"
    }), $acf0ff7f21bca477$var$_react2.default.createElement("path", {
        fill: "#321327",
        d: "M344.5 751.1c.7-2.2.7-5 .7-7.2 0-5.7-1.1-11.2-2.8-16.9l303.5-156.3c8.3 11.8 21.7 20.1 37.4 21.7L696.1 820c-16.2 3.3-29.1 14-36.3 28.4l-315.3-97.3zm189-466.6c9.4 14 25.6 23 43.6 23 3.9 0 7.9-.7 11.2-1.1l73.1 186.9c-8.3 5-15.1 12.3-20.1 20.6L330.9 406.2c.7-2.8 1.1-6.1 1.1-9.4 0-5-.7-10.1-2.2-15.1l203.7-97.2zM787 340.3c-.7 3.3-1.1 6.8-1.1 10.1 0 14 5 26.3 14 35.7l-85.3 107.2c-7.9-4.4-16.6-7.2-26.3-7.2-3.9 0-7.9.7-11.2 1.1L604 300.3c8.3-5 15.1-11.8 19.5-20.1L787 340.3zM879.5 616c-8.3 2.8-15.5 7.9-21.7 14.4l-119.9-72.7c2.2-5.5 3.3-11.8 3.3-18.4 0-14-5-26.3-14-35.7l85.3-107.2c7.9 4.4 16.6 7.2 26.3 7.2h1.1L879.5 616zm-580.8 74.9l-9.4-241.6c15.5-3.3 29.1-13.3 36.3-27.4l310.8 107.7c-.7 2.8-1.1 6.1-1.1 9.4 0 5.5 1.1 11.2 2.8 16.6l-303 156.3c-8.6-11.6-21.9-19.5-36.4-21zm413.4 128.2l-12.9-227.6c11.2-2.2 20.6-8.3 28-16.2l119.9 72.4c-2.2 5.7-3.3 11.8-3.3 18.4 0 12.3 4.4 24.1 11.2 32.8L735.5 828.1c-6.1-5-14.4-8.3-23.4-9zm184.7-206.3h-1.1l-39-212.7c20.6-7.2 35.2-26.7 35.2-50.3 0-29.5-23.4-53-53-53-20.1 0-37.4 11.2-46.4 27.4L629 264.5c.7-3.3 1.1-6.8 1.1-10.1 0-29.5-23.4-53-53-53-29.1 0-53 24.1-53 53 0 5 .7 10.1 2.2 15.1L322.8 367c-9.4-14-25.6-23-43.6-23-29.1 0-53 24.1-53 53 0 27.4 20.1 49.7 46.8 53l9.4 241.6c-24.5 5-42.5 26.3-42.5 51.9 0 29.5 23.4 53 53 53 20.6 0 39.2-12.3 47.5-29.5l315.4 97.6c-.7 2.2-.7 5-.7 7.2 0 29.5 23.4 53 53 53 29.1 0 53-24.1 53-53 0-12.3-4.4-24.1-11.2-32.8l119.5-128.9c8.3 5.5 18.4 9 29.5 9 29.1 0 53-24.1 53-53-1.9-29.5-25.5-53.3-55.1-53.3z"
    })));
};
$acf0ff7f21bca477$var$WrappedIcon.displayName = "AdobeSocialColorLight";
module.exports.default = $acf0ff7f21bca477$var$WrappedIcon;

});

parcelRegister("70Cv3", function(module, exports) {
module.exports = new URL("CircleExperienceCloud.69d1dfda.svg", import.meta.url).toString();

});


parcelRegister("6oEXm", function(module, exports) {

$parcel$export(module.exports, "IntlProvider", function () { return $4a84c10e7bc55b30$export$480518999dfc4151; });

var $fLJOt = parcelRequire("fLJOt");

var $5T7Bd = parcelRequire("5T7Bd");

var $8uciv = parcelRequire("8uciv");

var $7eprg = parcelRequire("7eprg");

var $54i2s = parcelRequire("54i2s");
var $dkc49 = parcelRequire("dkc49");

var $IQZYL = parcelRequire("IQZYL");

var $2l17e = parcelRequire("2l17e");

var $2Wx2p = parcelRequire("2Wx2p");

var $jsqOE = parcelRequire("jsqOE");

var $9U2Af = parcelRequire("9U2Af");

var $cwydM = parcelRequire("cwydM");

var $6VYBx = parcelRequire("6VYBx");
function $4a84c10e7bc55b30$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $4a84c10e7bc55b30$var$_isNativeReflectConstruct();
    return function() {
        var Super = (0, $cwydM.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $cwydM.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9U2Af.default)(this, result);
    };
}
function $4a84c10e7bc55b30$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Error thrown when no locale is provided to IntlProvider or any parent internationalization providers.
 */ var $4a84c10e7bc55b30$var$MissingLocaleError = /*#__PURE__*/ function(_Error) {
    (0, $jsqOE.default)(MissingLocaleError, _Error);
    var _super = $4a84c10e7bc55b30$var$_createSuper(MissingLocaleError);
    function MissingLocaleError() {
        (0, $2Wx2p.default)(this, MissingLocaleError);
        return _super.call(this, "[@quarry/intl Error MISSING_LOCALE] Missing locale for IntlProvider. Please provide a `locale` prop. If your IntlProvider is the child of another internationalization provider, you may provide a `locale` prop to only the parent provider and it will be used automatically.");
    }
    return MissingLocaleError;
}(/*#__PURE__*/ (0, $6VYBx.default)(Error));
function $4a84c10e7bc55b30$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4a84c10e7bc55b30$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $4a84c10e7bc55b30$var$ownKeys$1(Object(source), true).forEach(function(key) {
            (0, $2l17e.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $4a84c10e7bc55b30$var$ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Provides props and fallback behavior for a react-intl IntlProvider that's optionally nested inside another IntlProvider.
 * - Allows shareable components to internationalize themselves while applying settings like locale and messages from the parent context.
 * - Sets a default `defaultLocale` of 'en-US'.
 * - Lets locales with no country code fall back to BCP 47 language tags (ex: "xx-XX").
 *
 * The ideal use case for this hook is to provide props for an IntlProvider that wraps a shareable component meant for consumption in internationalized parent apps. It can also be used with an app's topmost IntlProvider for its defaultLocale and fallback features.
 *
 * In the future, this will also support communication with Adobe-Intl-React's I18nProvider and react-aria's I18nProvider as parent contexts.
 *
 * @param {IntlConfigWithAllMessages} intlConfig Props for the current internationalization context
 * @param {IntlConfigWithMessagesForLocale | IntlConfigWithAllMessages} parentIntlConfig Props for a parent internationalization context
 * @returns {ReactIntlProviderProps} Props for a react-intl `IntlProvider` component
 */ function $4a84c10e7bc55b30$export$30f449a498367b30(intlConfig) {
    var parentIntlConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var defaultLocale = intlConfig.defaultLocale, locale = intlConfig.locale;
    var parentDefaultLocale = parentIntlConfig.defaultLocale, parentLocale = parentIntlConfig.locale;
    defaultLocale = defaultLocale || parentDefaultLocale || "en-US";
    locale = locale || parentLocale;
    if (!locale) throw new $4a84c10e7bc55b30$var$MissingLocaleError();
    var messages = $4a84c10e7bc55b30$var$useMessages(intlConfig, parentIntlConfig);
    return {
        defaultLocale: defaultLocale,
        locale: locale,
        messages: messages
    };
}
/**
 * Return the messages to provide to a react-intl `IntlProvider`.
 *
 * 1. In the messages dictionary, convert "xx_XX" locale keys to "xx-XX"
 * 2. Choose the best available locale to return messages for
 * 3. Merge messages with messages from a parent internationalization context, if one exists
 *
 * @private
 * @param {IntlConfigWithAllMessages} intlConfig Props for the current internationalization context
 * @param {IntlConfigWithMessagesForLocale | IntlConfigWithAllMessages} parentIntlConfig Props for a parent internationalization context
 * @returns {Messages} Processed and merged messages for a react-intl `IntlProvider` component
 */ function $4a84c10e7bc55b30$var$useMessages(intlConfig) {
    var parentIntlConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var defaultLocale = intlConfig.defaultLocale, locale = intlConfig.locale, messages = intlConfig.messages;
    var parentDefaultLocale = parentIntlConfig.defaultLocale, parentLocale = parentIntlConfig.locale, parentMessages = parentIntlConfig.messages;
    var normalizedMessages = $4a84c10e7bc55b30$var$normalizeMessages(messages);
    var messagesOfLocale = $4a84c10e7bc55b30$var$getMessagesOfLocale(normalizedMessages, defaultLocale, locale, parentDefaultLocale, parentLocale);
    var mergedMessages = $4a84c10e7bc55b30$var$mergeMessagesOfLocaleWithParentMessages(parentLocale, messagesOfLocale, parentMessages);
    return mergedMessages;
}
/**
 * Converts hyphens to underscores and returns locale.
 *
 * @private
 * @param {string} locale Locale formatted as BCP 47 language tag, delimited by hyphen or underscore (ex: "xx-XX" or "xx_XX")
 * @returns {string} Locale with underscores replaced by hyphens (ex: "xx-XX")
 */ function $4a84c10e7bc55b30$var$normalizeLocale(locale) {
    return locale.replace(/_/g, "-");
}
/**
 * Normalize each locale key in a messages object.
 *
 * @private
 * @param {AllMessages} messages All messages
 * @returns {AllMessages} All messages with normalized locale keys
 */ function $4a84c10e7bc55b30$var$normalizeMessages(messages) {
    var normalizedMessages = {};
    for(var localeKey in messages)normalizedMessages[$4a84c10e7bc55b30$var$normalizeLocale(localeKey)] = messages[localeKey];
    return normalizedMessages;
}
/**
 * Type guard for the AllMessages type, to distinguish it from Messages.
 *
 * This crude implementation takes a messages object and a locale key, then
 * checks if the locale exists on the messages object. If it does, then we
 * assume that `messages` has locale string keys, so its type is AllMessages.
 *
 * @private
 * @param {Messages | AllMessages | undefined} messages Object of messages for an internationalization provider
 * @param {string} locale A locale key to search for in the messages object
 * @returns {messages is AllMessages}
 */ function $4a84c10e7bc55b30$var$isAllMessages(messages, locale) {
    return Boolean(messages) && messages[locale] !== undefined;
}
/**
 * Merge messages from `messages` prop and any parent messages, if they exist.
 *
 * @private
 * @param {string} parentLocale Parent provider's `locale` prop
 * @param {Messages} messagesOfLocale IntlProvider's messages for the best available locale
 * @param {Messages | AllMessages} parentMessages Parent provider's `messages` prop
 * @returns {Messages} Messages merged with parent messages
 */ function $4a84c10e7bc55b30$var$mergeMessagesOfLocaleWithParentMessages() {
    var parentLocale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var messagesOfLocale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var parentMessages = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var parentMessagesOfParentLocale = $4a84c10e7bc55b30$var$isAllMessages(parentMessages, parentLocale) ? parentMessages[parentLocale] || {} : parentMessages;
    return $4a84c10e7bc55b30$var$_objectSpread$1($4a84c10e7bc55b30$var$_objectSpread$1({}, parentMessagesOfParentLocale), messagesOfLocale);
}
/**
 * Return messages for the given locale.
 *
 * If any locale argument is missing a country code, it will be matched to the closest locale supported in `messages` that does include a country code.
 *
 * To determine the locale, the order of precedence is:
 * 1. locale
 * 2. parent locale
 * 3. default locale
 * 4. parent default locale
 * 5. "en-US"
 *
 * @private
 * @param {AllMessages} messages Messages with locale keys formatted as BCP 47 language tags (ex: "xx-XX")
 * @param {string | undefined} locale IntlProvider's `locale` prop
 * @param {string | undefined} defaultLocale IntlProvider's `defaultLocale` prop
 * @param {string | undefined} parentLocale Parent provider's `locale` prop
 * @param {string | undefined} parentDefaultLocale Parent provider's `defaultLocale` prop
 * @returns {Messages} Messages for the given locale
 */ function $4a84c10e7bc55b30$var$getMessagesOfLocale(messages, defaultLocale, locale, parentDefaultLocale, parentLocale) {
    var _map = [
        locale,
        parentLocale,
        defaultLocale,
        parentDefaultLocale
    ].map(function(loc) {
        return $4a84c10e7bc55b30$var$getClosestLocaleWithCountryCode(messages, loc);
    }), _map2 = (0, $IQZYL.default)(_map, 4), closestLocale = _map2[0], closestParentLocale = _map2[1], closestDefaultLocale = _map2[2], closestParentDefaultLocale = _map2[3];
    return messages[closestLocale] || messages[closestParentLocale] || messages[closestDefaultLocale] || messages[closestParentDefaultLocale] || messages["en-US"];
}
/**
 * If the locale is only a language code without a country code (ex: "ja"), search the supported locales and return the BCP 47 locale with that language code (ex: "ja-JP").
 *
 * @private
 * @param {AllMessages} messages Messages with locale keys formatted as BCP 47 language tags (ex: "xx-XX")
 * @param {string} locale Locale with language code and optional country code (ex: "xx" or "xx-XX")
 * @returns {string} The closest supported locale
 */ function $4a84c10e7bc55b30$var$getClosestLocaleWithCountryCode(messages, locale) {
    // In messages object, find the locale key that starts with the given locale prop.
    return Object.keys(messages).find(function(localeKey) {
        return locale && localeKey.startsWith(locale);
    }) || "";
}
/**
 * Returns internationalization props from a parent react-intl provider, if one exists.
 *
 * If none exists, returns an {@link IntlConfigWithMessagesForLocale|IntlConfigWithMessagesForLocale} object with empty fields.
 *
 * @private
 */ function $4a84c10e7bc55b30$var$useReactIntl() {
    try {
        var _useIntl = (0, $dkc49.default)(), defaultLocale = _useIntl.defaultLocale, locale = _useIntl.locale, messages = _useIntl.messages;
        return {
            defaultLocale: defaultLocale,
            locale: locale,
            messages: messages
        };
    } catch (e) {
        /**
     * When react-intl's useIntl() is called and no parent react-intl provider exists,
     * react-intl throws an error prepended with the string "[React Intl]".
     */ var hasNoReactIntlParent = e.message.includes("React Intl");
        if (hasNoReactIntlParent) return {
            defaultLocale: undefined,
            locale: undefined,
            messages: undefined
        };
         // Throw an unrelated error that occured.
        throw e;
    }
}
function $4a84c10e7bc55b30$var$useParentIntlProvider() {
    // TODO: handle other libs like Adobe-React-Intl, react-aria
    return $4a84c10e7bc55b30$var$useReactIntl();
}
var $4a84c10e7bc55b30$var$_excluded = [
    "children",
    "defaultLocale",
    "locale",
    "messages"
];
/**
 * Wraps a react-intl IntlProvider and augments it with extra features and fallback behavior.
 *
 * Gets info from a parent internationalization context if it exists, then delegates all logic to `useIntlProvider`.
 */ var $4a84c10e7bc55b30$export$480518999dfc4151 = function(_ref) {
    var children = _ref.children, defaultLocale = _ref.defaultLocale, locale = _ref.locale, messages = _ref.messages, props = (0, $8uciv.default)(_ref, $4a84c10e7bc55b30$var$_excluded);
    var intlConfig = {
        defaultLocale: defaultLocale,
        locale: locale,
        messages: messages
    };
    var parentIntlConfig = $4a84c10e7bc55b30$var$useParentIntlProvider();
    var intlProviderProps = (0, $7eprg.useMemo)(function() {
        return $4a84c10e7bc55b30$export$30f449a498367b30(intlConfig, parentIntlConfig);
    }, [].concat((0, $5T7Bd.default)(Object.values(intlConfig)), (0, $5T7Bd.default)(Object.values(parentIntlConfig))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $54i2s.default), (0, $fLJOt.default)({}, intlProviderProps, props), children);
};
function $4a84c10e7bc55b30$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4a84c10e7bc55b30$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $4a84c10e7bc55b30$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $2l17e.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $4a84c10e7bc55b30$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $4a84c10e7bc55b30$export$214f21c208335976 = function(dictionaries) {
    return dictionaries.reduce(function(aggregator, current) {
        for(var _i = 0, _Object$entries = Object.entries(current); _i < _Object$entries.length; _i++){
            var _Object$entries$_i = (0, $IQZYL.default)(_Object$entries[_i], 2), _key = _Object$entries$_i[0], value = _Object$entries$_i[1];
            aggregator[_key] = $4a84c10e7bc55b30$var$_objectSpread($4a84c10e7bc55b30$var$_objectSpread({}, aggregator[_key]), value);
        }
        return aggregator;
    }, {});
};

});
parcelRegister("5T7Bd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4497fbdfaa7d2433$export$2e2bcd8739ae039; });

var $14Qtt = parcelRequire("14Qtt");

var $b5BfQ = parcelRequire("b5BfQ");

var $6WAvn = parcelRequire("6WAvn");

var $epJus = parcelRequire("epJus");
function $4497fbdfaa7d2433$export$2e2bcd8739ae039(arr) {
    return (0, $14Qtt.default)(arr) || (0, $b5BfQ.default)(arr) || (0, $6WAvn.default)(arr) || (0, $epJus.default)();
}

});
parcelRegister("14Qtt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c8ede7db6a062a8$export$2e2bcd8739ae039; });

var $hGDgT = parcelRequire("hGDgT");
function $0c8ede7db6a062a8$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $hGDgT.default)(arr);
}

});
parcelRegister("hGDgT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce04d2636b3d7b0e$export$2e2bcd8739ae039; });
function $ce04d2636b3d7b0e$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("b5BfQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $812d0f505a518dfc$export$2e2bcd8739ae039; });
function $812d0f505a518dfc$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("6WAvn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50e47a075354992d$export$2e2bcd8739ae039; });

var $hGDgT = parcelRequire("hGDgT");
function $50e47a075354992d$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $hGDgT.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $hGDgT.default)(o, minLen);
}

});

parcelRegister("epJus", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7e6afe6883dd428$export$2e2bcd8739ae039; });
function $a7e6afe6883dd428$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("8uciv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62daaa1815ea5f7b$export$2e2bcd8739ae039; });

var $7uTSd = parcelRequire("7uTSd");
function $62daaa1815ea5f7b$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $7uTSd.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});

parcelRegister("54i2s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b0b5191372c4d07$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $2bLxa = parcelRequire("2bLxa");

var $7eprg = parcelRequire("7eprg");

var $a6smq = parcelRequire("a6smq");

var $kRaZB = parcelRequire("kRaZB");

var $lyeSI = parcelRequire("lyeSI");
var $cOQoo = parcelRequire("cOQoo");
var $6eAqc = parcelRequire("6eAqc");

var $hJn1O = parcelRequire("hJn1O");
function $3b0b5191372c4d07$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $3b0b5191372c4d07$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $hJn1O.isFormatXMLElementFn)(v) ? (0, $kRaZB.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $3b0b5191372c4d07$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $3b0b5191372c4d07$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $6eAqc.formatMessage).apply(void 0, (0, $2bLxa.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $7eprg.Children.toArray(chunks);
    return chunks;
};
var $3b0b5191372c4d07$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $2bLxa.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $3b0b5191372c4d07$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $lyeSI.createIntl)((0, $2bLxa.__assign)((0, $2bLxa.__assign)((0, $2bLxa.__assign)({}, (0, $kRaZB.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $2bLxa.__assign)((0, $2bLxa.__assign)({}, coreIntl), {
        // @ts-expect-error fix this
        formatMessage: $3b0b5191372c4d07$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $3b0b5191372c4d07$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};
var $3b0b5191372c4d07$var$IntlProvider = /** @class */ function(_super) {
    (0, $2bLxa.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $cOQoo.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: $3b0b5191372c4d07$export$7e4cbedfdd7b4c0d($3b0b5191372c4d07$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $3b0b5191372c4d07$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $3b0b5191372c4d07$var$processIntlConfig(props);
        if (!(0, $kRaZB.shallowEqual)(prevConfig, config)) return {
            intl: $3b0b5191372c4d07$export$7e4cbedfdd7b4c0d(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $kRaZB.invariantIntlContext)(this.state.intl);
        return $7eprg.createElement((0, $a6smq.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = "IntlProvider";
    IntlProvider.defaultProps = (0, $kRaZB.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($7eprg.PureComponent);
var $3b0b5191372c4d07$export$2e2bcd8739ae039 = $3b0b5191372c4d07$var$IntlProvider;

});
parcelRegister("hJn1O", function(module, exports) {

$parcel$export(module.exports, "isFormatXMLElementFn", function () { return $ce88808a37a2c306$export$df0c12a2d414a163; });

var $cxqhG = parcelRequire("cxqhG");

var $lP5Ix = parcelRequire("lP5Ix");
var $ce88808a37a2c306$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($ce88808a37a2c306$export$49694c2877b44c57 || ($ce88808a37a2c306$export$49694c2877b44c57 = {}));
function $ce88808a37a2c306$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $ce88808a37a2c306$export$49694c2877b44c57.literal || part.type !== $ce88808a37a2c306$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $ce88808a37a2c306$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $ce88808a37a2c306$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $cxqhG.isLiteralElement)(els[0])) return [
        {
            type: $ce88808a37a2c306$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $cxqhG.isLiteralElement)(el)) {
            result.push({
                type: $ce88808a37a2c306$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $cxqhG.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $ce88808a37a2c306$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $lP5Ix.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $cxqhG.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $ce88808a37a2c306$export$49694c2877b44c57.literal : $ce88808a37a2c306$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $cxqhG.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $cxqhG.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $ce88808a37a2c306$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $cxqhG.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $cxqhG.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $ce88808a37a2c306$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $cxqhG.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $cxqhG.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $ce88808a37a2c306$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $cxqhG.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$ce88808a37a2c306$export$df0c12a2d414a163(formatFn)) throw new (0, $lP5Ix.InvalidValueTypeError)(value_1, "function", originalMessage);
            var parts = $ce88808a37a2c306$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $ce88808a37a2c306$export$49694c2877b44c57.literal : $ce88808a37a2c306$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $cxqhG.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $lP5Ix.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $ce88808a37a2c306$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $cxqhG.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $lP5Ix.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $lP5Ix.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $lP5Ix.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $ce88808a37a2c306$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $ce88808a37a2c306$var$mergeLiteral(result);
}

});
parcelRegister("lP5Ix", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $fe32cbbb8e97c61e$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "FormatError", function () { return $fe32cbbb8e97c61e$export$7369836851cc1329; });
$parcel$export(module.exports, "InvalidValueError", function () { return $fe32cbbb8e97c61e$export$565c3afc07dfa382; });
$parcel$export(module.exports, "InvalidValueTypeError", function () { return $fe32cbbb8e97c61e$export$cbc0db47c750f7c9; });
$parcel$export(module.exports, "MissingValueError", function () { return $fe32cbbb8e97c61e$export$8bfc137e4d23fdf0; });

var $2bLxa = parcelRequire("2bLxa");
var $fe32cbbb8e97c61e$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($fe32cbbb8e97c61e$export$d4e71bc0b80dc0fb || ($fe32cbbb8e97c61e$export$d4e71bc0b80dc0fb = {}));
var $fe32cbbb8e97c61e$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $2bLxa.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $fe32cbbb8e97c61e$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $2bLxa.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $fe32cbbb8e97c61e$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($fe32cbbb8e97c61e$export$7369836851cc1329);
var $fe32cbbb8e97c61e$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $2bLxa.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $fe32cbbb8e97c61e$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($fe32cbbb8e97c61e$export$7369836851cc1329);
var $fe32cbbb8e97c61e$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $2bLxa.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $fe32cbbb8e97c61e$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($fe32cbbb8e97c61e$export$7369836851cc1329);

});



parcelRegister("dkc49", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b3680a468ddf307$export$2e2bcd8739ae039; });

var $7eprg = parcelRequire("7eprg");

var $a6smq = parcelRequire("a6smq");

var $kRaZB = parcelRequire("kRaZB");
function $9b3680a468ddf307$export$2e2bcd8739ae039() {
    var intl = $7eprg.useContext((0, $a6smq.Context));
    (0, $kRaZB.invariantIntlContext)(intl);
    return intl;
}

});

parcelRegister("IQZYL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $086d389b217ee898$export$2e2bcd8739ae039; });

var $9BapC = parcelRequire("9BapC");

var $dt6oZ = parcelRequire("dt6oZ");

var $6WAvn = parcelRequire("6WAvn");

var $cgBI0 = parcelRequire("cgBI0");
function $086d389b217ee898$export$2e2bcd8739ae039(arr, i) {
    return (0, $9BapC.default)(arr) || (0, $dt6oZ.default)(arr, i) || (0, $6WAvn.default)(arr, i) || (0, $cgBI0.default)();
}

});
parcelRegister("9BapC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6fcfa568f48077be$export$2e2bcd8739ae039; });
function $6fcfa568f48077be$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("dt6oZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ce2f3169c2a1398$export$2e2bcd8739ae039; });
function $9ce2f3169c2a1398$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("cgBI0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ee43ad488794c55$export$2e2bcd8739ae039; });
function $8ee43ad488794c55$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("2l17e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b3e687a9242e246$export$2e2bcd8739ae039; });

var $dbi4o = parcelRequire("dbi4o");
function $1b3e687a9242e246$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $dbi4o.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});
parcelRegister("dbi4o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $998a51b8bf11c7a3$export$2e2bcd8739ae039; });

var $eACMK = parcelRequire("eACMK");

var $cs45W = parcelRequire("cs45W");
function $998a51b8bf11c7a3$export$2e2bcd8739ae039(arg) {
    var key = (0, $cs45W.default)(arg, "string");
    return (0, $eACMK.default)(key) === "symbol" ? key : String(key);
}

});
parcelRegister("eACMK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9f28369f9dbd0cf$export$2e2bcd8739ae039; });
function $a9f28369f9dbd0cf$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $a9f28369f9dbd0cf$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a9f28369f9dbd0cf$export$2e2bcd8739ae039(o);
}

});

parcelRegister("cs45W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $910b46b1b1b07230$export$2e2bcd8739ae039; });

var $eACMK = parcelRequire("eACMK");
function $910b46b1b1b07230$export$2e2bcd8739ae039(input, hint) {
    if ((0, $eACMK.default)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $eACMK.default)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

});



parcelRegister("2Wx2p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $224aa0347f3e5589$export$2e2bcd8739ae039; });
function $224aa0347f3e5589$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("jsqOE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2a56eed0599ac5c$export$2e2bcd8739ae039; });

var $i09if = parcelRequire("i09if");
function $e2a56eed0599ac5c$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $i09if.default)(subClass, superClass);
}

});

parcelRegister("9U2Af", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $735b5912cc435950$export$2e2bcd8739ae039; });

var $eACMK = parcelRequire("eACMK");

var $01b32 = parcelRequire("01b32");
function $735b5912cc435950$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $eACMK.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $01b32.default)(self);
}

});

parcelRegister("cwydM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91e304cd63f7e9a6$export$2e2bcd8739ae039; });
function $91e304cd63f7e9a6$export$2e2bcd8739ae039(o) {
    $91e304cd63f7e9a6$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $91e304cd63f7e9a6$export$2e2bcd8739ae039(o);
}

});

parcelRegister("6VYBx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50c713bfb443b8e5$export$2e2bcd8739ae039; });

var $cwydM = parcelRequire("cwydM");

var $i09if = parcelRequire("i09if");

var $f843U = parcelRequire("f843U");

var $kkNG7 = parcelRequire("kkNG7");
function $50c713bfb443b8e5$export$2e2bcd8739ae039(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $50c713bfb443b8e5$export$2e2bcd8739ae039 = function _wrapNativeSuper(Class) {
        if (Class === null || !(0, $f843U.default)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $kkNG7.default)(Class, arguments, (0, $cwydM.default)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $i09if.default)(Wrapper, Class);
    };
    return $50c713bfb443b8e5$export$2e2bcd8739ae039(Class);
}

});
parcelRegister("f843U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b03ac104bfc7f945$export$2e2bcd8739ae039; });
function $b03ac104bfc7f945$export$2e2bcd8739ae039(fn) {
    try {
        return Function.toString.call(fn).indexOf("[native code]") !== -1;
    } catch (e) {
        return typeof fn === "function";
    }
}

});

parcelRegister("kkNG7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecdc35fe94a9e66a$export$2e2bcd8739ae039; });

var $i09if = parcelRequire("i09if");

var $khMN1 = parcelRequire("khMN1");
function $ecdc35fe94a9e66a$export$2e2bcd8739ae039(Parent, args, Class) {
    if ((0, $khMN1.default)()) $ecdc35fe94a9e66a$export$2e2bcd8739ae039 = Reflect.construct.bind();
    else $ecdc35fe94a9e66a$export$2e2bcd8739ae039 = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $i09if.default)(instance, Class.prototype);
        return instance;
    };
    return $ecdc35fe94a9e66a$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("khMN1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec4b3dc73ea648dc$export$2e2bcd8739ae039; });
function $ec4b3dc73ea648dc$export$2e2bcd8739ae039() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});




parcelRegister("7BDZy", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "de_DE", {
    enumerable: true,
    get: function() {
        return $589b02a7fd2fecd4$var$_de_de.default;
    }
});
Object.defineProperty(module.exports, "en_US", {
    enumerable: true,
    get: function() {
        return $589b02a7fd2fecd4$var$_en_us.default;
    }
});
Object.defineProperty(module.exports, "es_ES", {
    enumerable: true,
    get: function() {
        return $589b02a7fd2fecd4$var$_es_es.default;
    }
});
Object.defineProperty(module.exports, "fr_FR", {
    enumerable: true,
    get: function() {
        return $589b02a7fd2fecd4$var$_fr_fr.default;
    }
});
Object.defineProperty(module.exports, "it_IT", {
    enumerable: true,
    get: function() {
        return $589b02a7fd2fecd4$var$_it_it.default;
    }
});
Object.defineProperty(module.exports, "ja_JP", {
    enumerable: true,
    get: function() {
        return $589b02a7fd2fecd4$var$_ja_jp.default;
    }
});
Object.defineProperty(module.exports, "ko_KR", {
    enumerable: true,
    get: function() {
        return $589b02a7fd2fecd4$var$_ko_kr.default;
    }
});
Object.defineProperty(module.exports, "pt_BR", {
    enumerable: true,
    get: function() {
        return $589b02a7fd2fecd4$var$_pt_br.default;
    }
});
Object.defineProperty(module.exports, "zh_CN", {
    enumerable: true,
    get: function() {
        return $589b02a7fd2fecd4$var$_zh_cn.default;
    }
});
Object.defineProperty(module.exports, "zh_TW", {
    enumerable: true,
    get: function() {
        return $589b02a7fd2fecd4$var$_zh_tw.default;
    }
});

var $589b02a7fd2fecd4$var$_en_us = $l4FIw((parcelRequire("gMTPu")));

var $589b02a7fd2fecd4$var$_ko_kr = $l4FIw((parcelRequire("kKAkA")));

var $589b02a7fd2fecd4$var$_zh_tw = $l4FIw((parcelRequire("g8EKc")));

var $589b02a7fd2fecd4$var$_zh_cn = $l4FIw((parcelRequire("3wNet")));

var $589b02a7fd2fecd4$var$_pt_br = $l4FIw((parcelRequire("fCodg")));

var $589b02a7fd2fecd4$var$_it_it = $l4FIw((parcelRequire("kGMKp")));

var $589b02a7fd2fecd4$var$_es_es = $l4FIw((parcelRequire("cWoa4")));

var $589b02a7fd2fecd4$var$_ja_jp = $l4FIw((parcelRequire("fG8PL")));

var $589b02a7fd2fecd4$var$_de_de = $l4FIw((parcelRequire("6WoZD")));

var $589b02a7fd2fecd4$var$_fr_fr = $l4FIw((parcelRequire("awYg5")));

});
parcelRegister("gMTPu", function(module, exports) {
module.exports = JSON.parse('{"DeleteReminder":"Delete reminder","EditReminder":"Edit reminder","RemindMe15Min":"Remind me in 15 Minutes","RemindMe5Min":"Remind me in 5 Minutes","RemindMe60Min":"Remind me in an Hour","RemindMeTomorrow":"Remind me tomorrow","SetReminder":"Reminder set for {formattedReminderTime}","Snooze":"Snooze"}');

});

parcelRegister("kKAkA", function(module, exports) {
module.exports = JSON.parse('{"DeleteReminder":"\uBBF8\uB9AC \uC54C\uB9BC \uC0AD\uC81C","EditReminder":"\uBBF8\uB9AC \uC54C\uB9BC \uD3B8\uC9D1","RemindMe15Min":"15\uBD84 \uD6C4 \uB2E4\uC2DC \uC54C\uB9AC\uAE30","RemindMe5Min":"5\uBD84 \uD6C4 \uB2E4\uC2DC \uC54C\uB9AC\uAE30","RemindMe60Min":"1\uC2DC\uAC04 \uD6C4 \uB2E4\uC2DC \uC54C\uB9AC\uAE30","RemindMeTomorrow":"\uB0B4\uC77C \uB2E4\uC2DC \uC54C\uB9AC\uAE30","SetReminder":"{formattedReminderTime}\uC5D0 \uC124\uC815\uB41C \uBBF8\uB9AC \uC54C\uB9BC","Snooze":"\uB2E4\uC2DC \uC54C\uB9BC"}');

});

parcelRegister("g8EKc", function(module, exports) {
module.exports = JSON.parse('{"DeleteReminder":"\u522A\u9664\u63D0\u9192","EditReminder":"\u7DE8\u8F2F\u63D0\u9192","RemindMe15Min":"15 \u5206\u9418\u5F8C\u518D\u63D0\u9192\u6211","RemindMe5Min":"5 \u5206\u9418\u5F8C\u518D\u63D0\u9192\u6211","RemindMe60Min":"\u4E00\u5C0F\u6642\u5F8C\u518D\u63D0\u9192\u6211","RemindMeTomorrow":"\u660E\u5929\u518D\u63D0\u9192\u6211","SetReminder":"\u5DF2\u8A2D\u5B9A\u63D0\u9192\u6642\u9593: {formattedReminderTime}","Snooze":"\u518D\u6B21\u63D0\u9192"}');

});

parcelRegister("3wNet", function(module, exports) {
module.exports = JSON.parse('{"DeleteReminder":"\u5220\u9664\u63D0\u9192","EditReminder":"\u7F16\u8F91\u63D0\u9192","RemindMe15Min":"15 \u5206\u949F\u540E\u63D0\u9192\u6211","RemindMe5Min":"5 \u5206\u949F\u540E\u63D0\u9192\u6211","RemindMe60Min":"1 \u5C0F\u65F6\u540E\u63D0\u9192\u6211","RemindMeTomorrow":"\u660E\u5929\u63D0\u9192\u6211","SetReminder":"\u63D0\u9192\u65F6\u95F4\u4E3A: {formattedReminderTime}","Snooze":"\u518D\u6B21\u63D0\u9192"}');

});

parcelRegister("fCodg", function(module, exports) {
module.exports = JSON.parse('{"DeleteReminder":"Excluir lembrete","EditReminder":"Editar lembrete","RemindMe15Min":"Lembre-me em 15 minutos","RemindMe5Min":"Lembre-me em 5 minutos","RemindMe60Min":"Lembre-me em uma hora","RemindMeTomorrow":"Lembre-me amanh\xe3","SetReminder":"Lembrete definido para {formattedReminderTime}","Snooze":"Adiar"}');

});

parcelRegister("kGMKp", function(module, exports) {
module.exports = JSON.parse('{"DeleteReminder":"Elimina promemoria","EditReminder":"Modifica promemoria","RemindMe15Min":"Ricordami tra 15 minuti","RemindMe5Min":"Ricordami tra 5 minuti","RemindMe60Min":"Ricordami tra 1 ora","RemindMeTomorrow":"Ricordami domani","SetReminder":"Promemoria impostato per {formattedReminderTime}","Snooze":"Posponi"}');

});

parcelRegister("cWoa4", function(module, exports) {
module.exports = JSON.parse('{"DeleteReminder":"Borrar recordatorio","EditReminder":"Editar recordatorio","RemindMe15Min":"Recordatorio en 15 minutos","RemindMe5Min":"Recordatorio en 5 minutos","RemindMe60Min":"Recordatorio en una hora","RemindMeTomorrow":"Recordatorio ma\xf1ana","SetReminder":"Recordatorio establecido para {formattedReminderTime}","Snooze":"Posponer"}');

});

parcelRegister("fG8PL", function(module, exports) {
module.exports = JSON.parse('{"DeleteReminder":"\u30EA\u30DE\u30A4\u30F3\u30C0\u30FC\u3092\u524A\u9664","EditReminder":"\u30EA\u30DE\u30A4\u30F3\u30C0\u30FC\u3092\u7DE8\u96C6","RemindMe15Min":"15 \u5206\u5F8C\u306B\u901A\u77E5","RemindMe5Min":"5 \u5206\u5F8C\u306B\u901A\u77E5","RemindMe60Min":"1 \u6642\u9593\u5F8C\u306B\u901A\u77E5","RemindMeTomorrow":"\u660E\u65E5\u901A\u77E5","SetReminder":"{formattedReminderTime} \u306E\u30EA\u30DE\u30A4\u30F3\u30C0\u30FC\u8A2D\u5B9A","Snooze":"\u518D\u901A\u77E5"}');

});

parcelRegister("6WoZD", function(module, exports) {
module.exports = JSON.parse('{"DeleteReminder":"Erinnerung l\xf6schen","EditReminder":"Erinnerung bearbeiten","RemindMe15Min":"Erinnere mich in 15 Minuten","RemindMe5Min":"Erinnere mich in 5 Minuten","RemindMe60Min":"Erinnere mich in einer Stunde","RemindMeTomorrow":"Erinnere mich morgen","SetReminder":"Erinnerung eingerichtet f\xfcr {formattedReminderTime}","Snooze":"Schlummern"}');

});

parcelRegister("awYg5", function(module, exports) {
module.exports = JSON.parse('{"DeleteReminder":"Supprimer le rappel","EditReminder":"Modifier le rappel","RemindMe15Min":"Me le rappeler dans 15\xa0minutes","RemindMe5Min":"Me le rappeler dans 5\xa0minutes","RemindMe60Min":"Me le rappeler dans une heure","RemindMeTomorrow":"Me le rappeler demain","SetReminder":"Rappel d\xe9fini pour {formattedReminderTime}","Snooze":"R\xe9p\xe9ter"}');

});



parcelRegister("afE2Z", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "de_DE", {
    enumerable: true,
    get: function() {
        return $776a5ea37a9daae1$var$_de_de.default;
    }
});
Object.defineProperty(module.exports, "en_US", {
    enumerable: true,
    get: function() {
        return $776a5ea37a9daae1$var$_en_us.default;
    }
});
Object.defineProperty(module.exports, "es_ES", {
    enumerable: true,
    get: function() {
        return $776a5ea37a9daae1$var$_es_es.default;
    }
});
Object.defineProperty(module.exports, "fr_FR", {
    enumerable: true,
    get: function() {
        return $776a5ea37a9daae1$var$_fr_fr.default;
    }
});
Object.defineProperty(module.exports, "it_IT", {
    enumerable: true,
    get: function() {
        return $776a5ea37a9daae1$var$_it_it.default;
    }
});
Object.defineProperty(module.exports, "ja_JP", {
    enumerable: true,
    get: function() {
        return $776a5ea37a9daae1$var$_ja_jp.default;
    }
});
Object.defineProperty(module.exports, "ko_KR", {
    enumerable: true,
    get: function() {
        return $776a5ea37a9daae1$var$_ko_kr.default;
    }
});
Object.defineProperty(module.exports, "pt_BR", {
    enumerable: true,
    get: function() {
        return $776a5ea37a9daae1$var$_pt_br.default;
    }
});
Object.defineProperty(module.exports, "zh_CN", {
    enumerable: true,
    get: function() {
        return $776a5ea37a9daae1$var$_zh_cn.default;
    }
});
Object.defineProperty(module.exports, "zh_TW", {
    enumerable: true,
    get: function() {
        return $776a5ea37a9daae1$var$_zh_tw.default;
    }
});

var $776a5ea37a9daae1$var$_en_us = $l4FIw((parcelRequire("kEYsV")));

var $776a5ea37a9daae1$var$_ko_kr = $l4FIw((parcelRequire("4EuxW")));

var $776a5ea37a9daae1$var$_zh_tw = $l4FIw((parcelRequire("RGS9j")));

var $776a5ea37a9daae1$var$_zh_cn = $l4FIw((parcelRequire("4Fyt6")));

var $776a5ea37a9daae1$var$_pt_br = $l4FIw((parcelRequire("4h8fX")));

var $776a5ea37a9daae1$var$_it_it = $l4FIw((parcelRequire("cNubs")));

var $776a5ea37a9daae1$var$_es_es = $l4FIw((parcelRequire("29v8m")));

var $776a5ea37a9daae1$var$_ja_jp = $l4FIw((parcelRequire("6UEs2")));

var $776a5ea37a9daae1$var$_de_de = $l4FIw((parcelRequire("bLkFg")));

var $776a5ea37a9daae1$var$_fr_fr = $l4FIw((parcelRequire("bqSCP")));

});
parcelRegister("kEYsV", function(module, exports) {
module.exports = JSON.parse('{"Approve":"Approve","DeleteReminder":"Delete reminder","DismissAlert":"Dismiss","DismissReminder":"Dismiss reminder","EditReminder":"Edit reminder","High":"High","Reject":"Reject","RemindMe15Min":"Remind me in 15 minutes","RemindMe5Min":"Remind me in 5 minutes","RemindMe60Min":"Remind me in an hour","RemindMeTomorrow":"Remind me tomorrow","Snooze":"Remind me","markAsRead":"Mark as read","markAsUnread":"Mark as unread"}');

});

parcelRegister("4EuxW", function(module, exports) {
module.exports = JSON.parse('{"Approve":"\uC2B9\uC778","DeleteReminder":"\uBBF8\uB9AC \uC54C\uB9BC \uC0AD\uC81C","DismissAlert":"\uB2EB\uAE30","DismissReminder":"\uBBF8\uB9AC \uC54C\uB9BC \uB2EB\uAE30","EditReminder":"\uBBF8\uB9AC \uC54C\uB9BC \uD3B8\uC9D1","High":"\uB192\uC74C","Reject":"\uAC70\uBD80","RemindMe15Min":"15\uBD84 \uD6C4\uC5D0 \uB2E4\uC2DC \uC54C\uB9AC\uAE30","RemindMe5Min":"5\uBD84 \uD6C4\uC5D0 \uB2E4\uC2DC \uC54C\uB9AC\uAE30","RemindMe60Min":"1\uC2DC\uAC04 \uD6C4\uC5D0 \uB2E4\uC2DC \uC54C\uB9AC\uAE30","RemindMeTomorrow":"\uB0B4\uC77C \uB2E4\uC2DC \uC54C\uB9AC\uAE30","Snooze":"\uB2E4\uC2DC \uC54C\uB9AC\uAE30","markAsRead":"\uC77D\uC74C\uC73C\uB85C \uD45C\uC2DC","markAsUnread":"\uC77D\uC9C0 \uC54A\uC74C\uC73C\uB85C \uD45C\uC2DC"}');

});

parcelRegister("RGS9j", function(module, exports) {
module.exports = JSON.parse('{"Approve":"\u6838\u51C6","DeleteReminder":"\u522A\u9664\u63D0\u9192","DismissAlert":"\u95DC\u9589","DismissReminder":"\u95DC\u9589\u63D0\u9192","EditReminder":"\u7DE8\u8F2F\u63D0\u9192","High":"\u9AD8","Reject":"\u62D2\u7D55","RemindMe15Min":"15 \u5206\u9418\u5F8C\u518D\u63D0\u9192\u6211","RemindMe5Min":"5 \u5206\u9418\u5F8C\u518D\u63D0\u9192\u6211","RemindMe60Min":"1 \u5C0F\u6642\u5F8C\u518D\u63D0\u9192\u6211","RemindMeTomorrow":"\u660E\u5929\u518D\u63D0\u9192\u6211","Snooze":"\u63D0\u9192\u6211","markAsRead":"\u6A19\u8A18\u70BA\u5DF2\u8B80","markAsUnread":"\u6A19\u8A18\u70BA\u672A\u8B80"}');

});

parcelRegister("4Fyt6", function(module, exports) {
module.exports = JSON.parse('{"Approve":"\u540C\u610F","DeleteReminder":"\u5220\u9664\u63D0\u9192","DismissAlert":"\u53D6\u6D88","DismissReminder":"\u53D6\u6D88\u63D0\u9192","EditReminder":"\u7F16\u8F91\u63D0\u9192","High":"\u9AD8","Reject":"\u62D2\u7EDD","RemindMe15Min":"15 \u5206\u949F\u540E\u63D0\u9192\u6211","RemindMe5Min":"5 \u5206\u949F\u540E\u63D0\u9192\u6211","RemindMe60Min":"1 \u5C0F\u65F6\u540E\u63D0\u9192\u6211","RemindMeTomorrow":"\u660E\u5929\u63D0\u9192\u6211","Snooze":"\u63D0\u9192\u6211","markAsRead":"\u6807\u8BB0\u4E3A\u5DF2\u8BFB","markAsUnread":"\u6807\u8BB0\u4E3A\u672A\u8BFB"}');

});

parcelRegister("4h8fX", function(module, exports) {
module.exports = JSON.parse('{"Approve":"Aprovar","DeleteReminder":"Excluir lembrete","DismissAlert":"Ignorar","DismissReminder":"Ignorar lembrete","EditReminder":"Editar lembrete","High":"ALTA","Reject":"Rejeitar","RemindMe15Min":"Lembrar em 15 minutos","RemindMe5Min":"Lembrar em 5 minutos","RemindMe60Min":"Lembrar em uma hora","RemindMeTomorrow":"Lembre-me amanh\xe3","Snooze":"Lembre-me","markAsRead":"Marcar como lido","markAsUnread":"Marcar como n\xe3o lido"}');

});

parcelRegister("cNubs", function(module, exports) {
module.exports = JSON.parse('{"Approve":"Approva","DeleteReminder":"Elimina promemoria","DismissAlert":"Ignora","DismissReminder":"Ignora promemoria","EditReminder":"Modifica promemoria","High":"Alta","Reject":"Rifiuta","RemindMe15Min":"Ricordami tra 15 minuti","RemindMe5Min":"Ricordami tra 5 minuti","RemindMe60Min":"Ricordami tra 1 ora","RemindMeTomorrow":"Ricordami domani","Snooze":"Attiva promemoria","markAsRead":"Segna come letto","markAsUnread":"Segna come non letto"}');

});

parcelRegister("29v8m", function(module, exports) {
module.exports = JSON.parse('{"Approve":"Aprobar","DeleteReminder":"Borrar recordatorio","DismissAlert":"Descartar","DismissReminder":"Descartar recordatorio","EditReminder":"Editar recordatorio","High":"Alto","Reject":"Rechazar","RemindMe15Min":"Recordatorio en 15 minutos","RemindMe5Min":"Recordatorio en 5 minutos","RemindMe60Min":"Recordatorio en una hora","RemindMeTomorrow":"Recordatorio ma\xf1ana","Snooze":"Recordarme","markAsRead":"Marcar como le\xeddo","markAsUnread":"Marcar como no le\xeddo"}');

});

parcelRegister("6UEs2", function(module, exports) {
module.exports = JSON.parse('{"Approve":"\u627F\u8A8D","DeleteReminder":"\u30EA\u30DE\u30A4\u30F3\u30C0\u30FC\u3092\u524A\u9664","DismissAlert":"\u4E86\u89E3","DismissReminder":"\u30EA\u30DE\u30A4\u30F3\u30C0\u30FC\u3092\u89E3\u9664","EditReminder":"\u30EA\u30DE\u30A4\u30F3\u30C0\u30FC\u3092\u7DE8\u96C6","High":"\u9AD8","Reject":"\u62D2\u5426","RemindMe15Min":"15 \u5206\u5F8C\u306B\u901A\u77E5","RemindMe5Min":"5 \u5206\u5F8C\u306B\u901A\u77E5","RemindMe60Min":"1 \u6642\u9593\u5F8C\u306B\u901A\u77E5","RemindMeTomorrow":"\u660E\u65E5\u901A\u77E5","Snooze":"\u5F8C\u3067\u901A\u77E5\u3059\u308B","markAsRead":"\u65E2\u8AAD\u3068\u3057\u3066\u30DE\u30FC\u30AF","markAsUnread":"\u672A\u8AAD\u3068\u3057\u3066\u30DE\u30FC\u30AF"}');

});

parcelRegister("bLkFg", function(module, exports) {
module.exports = JSON.parse('{"Approve":"Genehmigen","DeleteReminder":"Erinnerung l\xf6schen","DismissAlert":"Verwerfen","DismissReminder":"Erinnerung verwerfen","EditReminder":"Erinnerung bearbeiten","High":"Hoch","Reject":"Ablehnen","RemindMe15Min":"Erinnere mich in 15 Minuten","RemindMe5Min":"Erinnere mich in 5 Minuten","RemindMe60Min":"Erinnere mich in einer Stunde","RemindMeTomorrow":"Erinnere mich morgen","Snooze":"Erinnern","markAsRead":"Als gelesen markieren","markAsUnread":"Als ungelesen markieren"}');

});

parcelRegister("bqSCP", function(module, exports) {
module.exports = JSON.parse('{"Approve":"Approuver","DeleteReminder":"Supprimer le rappel","DismissAlert":"Ignorer","DismissReminder":"Rejeter le rappel","EditReminder":"Modifier le rappel","High":"PRIORITAIRE","Reject":"Rejeter","RemindMe15Min":"Me le rappeler dans 15\xa0minutes","RemindMe5Min":"Me le rappeler dans 5\xa0minutes","RemindMe60Min":"Me le rappeler dans une heure","RemindMeTomorrow":"Me le rappeler demain","Snooze":"Me le rappeler","markAsRead":"Marquer comme lu","markAsUnread":"Marquer comme non lu"}');

});



parcelRegister("gM7LE", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c367277e6e954f92$var$_react = $l4FIw((parcelRequire("7eprg")));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/ const $c367277e6e954f92$var$Card = (_ref)=>{
    let { children: children } = _ref;
    return /*#__PURE__*/ $c367277e6e954f92$var$_react.default.createElement("div", {
        className: "card"
    }, children);
};
var $c367277e6e954f92$var$_default = $c367277e6e954f92$var$Card;
module.exports.default = $c367277e6e954f92$var$_default;

});


//# sourceMappingURL=PulseWidgetWrapper.0ea8b859.js.map
